(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   F45 — ANNOUNCEMENT MARQUEE RELIABILITY.
   The bar is a CSS marquee: the message list is rendered TWICE and the track slides from 0 to
   -50% (exactly one copy) on an infinite linear animation, so the wrap is seamless — PROVIDED
   one copy is at least as wide as the bar. When it is not (few/short messages, or a wide
   desktop), the tail of the list clears the right edge before the wrap, leaving a visible gap
   and making the last message look skipped. This measures the real widths and appends whole
   extra copies until one "half" of the track covers the bar, then rescales the duration so the
   scroll SPEED (seconds per message) is unchanged.

   There are no timers here — the animation is CSS — so there is nothing to double-start and
   nothing that a scroll can restart. Width is re-measured only when the width ACTUALLY changes
   (mobile URL-bar show/hide fires resize with an unchanged width, which must not restart the
   animation mid-message). Tab-inactivity pausing is explicit so a throttled background tab can
   never desync, and reduced motion opts out entirely.
   ============================================================ */
(function () {
  'use strict';
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function fit(bar) {
    if (RM.matches) return;
    var track = bar.querySelector('.bb-marquee__track');
    if (!track) return;
    var count = parseInt(bar.getAttribute('data-count'), 10) || 1;
    var spm = parseFloat(bar.getAttribute('data-spm')) || 7;
    var barW = bar.clientWidth;
    if (!barW) return;

    // One "unit" = the markup Liquid rendered once (the track ships exactly 2 of them). Clone
    // the SECOND copy, not the first: Liquid already marks that one aria-hidden/tabindex="-1"
    // because it is a visual duplicate. Cloning the first would put every extra copy's links
    // back into the tab order and have screen readers announce the list once per copy.
    if (!bar.__bbUnit) {
      var kids = Array.prototype.slice.call(track.children);
      bar.__bbUnit = kids.slice(kids.length / 2).map(function (n) { return n.cloneNode(true); });
      bar.__bbUnits = 2;
    }
    var unitW = track.scrollWidth / bar.__bbUnits;
    if (!unitW) return;

    // halves must each cover the bar: halves = units / 2
    var needHalves = Math.max(1, Math.ceil(barW / unitW));
    var needUnits = needHalves * 2;
    if (needUnits !== bar.__bbUnits) {
      if (needUnits > bar.__bbUnits) {
        var frag = document.createDocumentFragment();
        for (var i = bar.__bbUnits; i < needUnits; i++) {
          bar.__bbUnit.forEach(function (n) { frag.appendChild(n.cloneNode(true)); });
        }
        track.appendChild(frag);
      } else {
        var perUnit = bar.__bbUnit.length;
        while (track.children.length > needUnits * perUnit) track.removeChild(track.lastChild);
      }
      bar.__bbUnits = needUnits;
    }
    // constant speed: one half now carries needHalves copies of the list
    track.style.setProperty('--bb-marquee-dur', (needHalves * count * spm) + 's');
    bar.__bbW = barW;
  }

  function bind(scope) {
    var bars = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-bb-marquee]');
    bars.forEach(function (bar) {
      if (bar.__bbMqBound) return;
      bar.__bbMqBound = 1;
      fit(bar);
      // fonts land after first paint and change every measurement
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(bar); });
    });
  }

  var rz = null;
  window.addEventListener('resize', function () {
    if (rz) clearTimeout(rz);
    rz = setTimeout(function () {
      rz = null;
      document.querySelectorAll('[data-bb-marquee]').forEach(function (bar) {
        if (bar.clientWidth === bar.__bbW) return; // height-only resize (URL bar) — leave it running
        fit(bar);
      });
    }, 200);
  }, { passive: true });

  /* a background tab throttles compositor animations; pause explicitly and resume on return so
     the cycle always continues from where it stopped rather than drifting */
  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll('[data-bb-marquee] .bb-marquee__track').forEach(function (t) {
      /* resume by CLEARING the inline value, never by writing 'running': an inline declaration
         outranks the stylesheet, so forcing 'running' here would permanently override the
         desktop hover-pause rule (and the merchant's pause_on_hover setting) after the first
         tab switch. */
      t.style.animationPlayState = document.hidden ? 'paused' : '';
    });
  });

  if (document.readyState !== 'loading') bind(document);
  else document.addEventListener('DOMContentLoaded', function () { bind(document); });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-about-video-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var MOB = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };

  function init(scope) {
    (scope || document).querySelectorAll('[data-bb-avh]').forEach(function (root) {
      if (root.__bbAvh) return;
      root.__bbAvh = 1;
      var video = root.querySelector('[data-bb-avh-video]');
      if (!video) return;

      function loadSource() {
        if (video.getAttribute('src')) return;
        var src = video.getAttribute('data-src');
        if (src) video.setAttribute('src', src);
      }
      function nudge() {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }

      function activate() {
        // mobile-only: never assign the source on desktop (section is display:none there)
        if (!MOB.matches) return;
        loadSource();
        video.muted = true; // property, not just attribute — required for reliable mobile autoplay
        if (RM.matches || !root.hasAttribute('data-autoplay')) return; // reduced motion / off → poster stays, no control
        nudge(); // nudge beside the native `autoplay` attribute — NOT a retry loop
      }

      /* F27b — NO play button. If muted autoplay is blocked (iOS Low Power Mode), the FIRST user
         gesture ANYWHERE on the page silently starts the video; one-shot, self-removing, and it
         also retries once the video can actually play. Nothing visible, ever. */
      var kicked = false;
      var GEVTS = ['touchstart', 'pointerdown', 'scroll', 'keydown', 'click'];
      var gopts = { passive: true, capture: true };
      function unbindKick() { GEVTS.forEach(function (ev) { window.removeEventListener(ev, kick, gopts); }); }
      function kick() {
        if (kicked || !MOB.matches || RM.matches) return;
        kicked = true;
        unbindKick();
        loadSource();
        video.muted = true;
        nudge();
      }
      if (!RM.matches) GEVTS.forEach(function (ev) { window.addEventListener(ev, kick, gopts); });

      function reveal() { root.classList.add('bb-avh--playing'); unbindKick(); }
      video.addEventListener('playing', reveal);
      /* F29 — timeupdate is the authoritative "really moving" signal (some iOS builds fire
         `playing` unreliably); lifts the poster once the video actually advances so it can never
         sit frozen over a playing video. */
      video.addEventListener('timeupdate', function () { if (video.currentTime > 0.05) reveal(); });
      video.addEventListener('loadeddata', function () { if (MOB.matches && !RM.matches && video.paused && root.hasAttribute('data-autoplay')) nudge(); });
      video.addEventListener('canplay', function () { if (MOB.matches && !RM.matches && video.paused && root.hasAttribute('data-autoplay')) nudge(); });

      // F27 — pause when scrolled fully out of view (battery/CPU), resume on return; pause()
      // preserves currentTime so nothing restarts. Hysteresis: resume at >=20%, pause at 0%.
      if ('IntersectionObserver' in window) {
        var ioIn = true;
        new IntersectionObserver(function (entries) {
          var e = entries[entries.length - 1];
          if (!MOB.matches || !video.getAttribute('src')) return;
          if (e.intersectionRatio === 0 && ioIn) { ioIn = false; try { video.pause(); } catch (err) {} }
          else if (e.intersectionRatio >= 0.2 && !ioIn) {
            ioIn = true;
            if (!RM.matches && root.hasAttribute('data-autoplay')) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          }
        }, { threshold: [0, 0.2] }).observe(root);
      }

      // Lift the scroll cue above the fold by however far the 100svh frame overshoots
      // the viewport at page top (the announcement-bar offset once the transparent-YMM
      // pull is active) — same approach as the homepage hero's control lift.
      var frame = root.querySelector('.bb-avh__frame');
      function measureLift() {
        if (!frame || window.scrollY > 4 || !MOB.matches) return;
        var over = Math.round(frame.getBoundingClientRect().bottom - window.innerHeight);
        if (over < 0) over = 0;
        if (over > 80) over = 80;
        root.style.setProperty('--bb-avh-lift', over + 'px');
      }
      measureLift();
      [150, 600].forEach(function (t) { setTimeout(measureLift, t); });
      window.addEventListener('resize', measureLift, { passive: true });

      /* F35 — desktop editorial video: separate element, src assigned only on >=750px viewports;
         same poster-until-playing reveal (timeupdate is the authoritative signal). */
      var dvideo = root.querySelector('[data-bb-avh-dvideo]');
      function dReveal() { root.classList.add('bb-avh--d-playing'); }
      function dActivate() {
        if (!dvideo || MOB.matches) return;
        if (!dvideo.getAttribute('src')) { var ds = dvideo.getAttribute('data-src'); if (ds) dvideo.setAttribute('src', ds); }
        dvideo.muted = true;
        if (RM.matches || !root.hasAttribute('data-autoplay')) return; /* reduced motion: poster stays */
        var p = dvideo.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (dvideo) {
        dvideo.addEventListener('playing', dReveal);
        dvideo.addEventListener('timeupdate', function () { if (dvideo.currentTime > 0.05) dReveal(); });
        dvideo.addEventListener('canplay', function () { if (!MOB.matches && !RM.matches && dvideo.paused && root.hasAttribute('data-autoplay')) { var p = dvideo.play(); if (p && p.catch) p.catch(function () {}); } });
        if ('IntersectionObserver' in window) {
          var dIn = true;
          new IntersectionObserver(function (entries) {
            var e = entries[entries.length - 1];
            if (MOB.matches || !dvideo.getAttribute('src')) return;
            if (e.intersectionRatio === 0 && dIn) { dIn = false; try { dvideo.pause(); } catch (err) {} }
            else if (e.intersectionRatio >= 0.2 && !dIn) { dIn = true; if (!RM.matches && root.hasAttribute('data-autoplay')) { var p = dvideo.play(); if (p && p.catch) p.catch(function () {}); } }
          }, { threshold: [0, 0.2] }).observe(dvideo);
        }
      }

      activate();
      dActivate();
      if (MOB.addEventListener) MOB.addEventListener('change', function (e) {
        if (e.matches) { activate(); if (dvideo) { try { dvideo.pause(); } catch (err) {} } }
        else { try { video.pause(); } catch (err) {} dActivate(); }
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-bundle"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fmt(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format((cents || 0) / 100);
    } catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function init(root) {
    if (root.dataset.bbReady) return;
    root.dataset.bbReady = '1';

    var basis = root.dataset.basis || 'count';
    var tiers = [];
    try { tiers = JSON.parse(root.dataset.tiers || '[]').filter(function (t) { return t.pct > 0; }).sort(function (a, b) { return a.min - b.min; }); } catch (e) {}

    var modelSel = root.querySelector('[data-bundle-model]');
    var groups = root.querySelectorAll('[data-bundle-group]');
    var search = root.querySelector('[data-bundle-search]');
    var clearBtn = root.querySelector('[data-bundle-clear]');
    var results = root.querySelector('[data-bundle-results]');
    var defaultWrap = root.querySelector('[data-bundle-default]');
    var noResults = root.querySelector('[data-bundle-noresults]');
    var recsWrap = root.querySelector('[data-bundle-recs]');
    var recsList = root.querySelector('[data-bundle-recs-list]');
    var selWrap = root.querySelector('[data-bundle-selected]');
    var emptySel = root.querySelector('[data-bundle-empty-sel]');
    var tiersWrap = root.querySelector('[data-bundle-tiers]');
    var summary = root.querySelector('.bb-bundle__summary');
    var sheetBtn = root.querySelector('[data-bundle-sheet]');
    var el = {
      count: root.querySelector('[data-bundle-count]'), qty: root.querySelector('[data-bundle-qty]'),
      nudge: root.querySelector('[data-bundle-nudge]'), sub: root.querySelector('[data-bundle-subtotal]'),
      discRow: root.querySelector('[data-bundle-discount-row]'), discLabel: root.querySelector('[data-bundle-discount-label]'),
      disc: root.querySelector('[data-bundle-discount]'), total: root.querySelector('[data-bundle-total]'), add: root.querySelector('[data-bundle-add]'),
      barCount: root.querySelector('[data-bundle-bar-count]'), barTotal: root.querySelector('[data-bundle-bar-total]')
    };

    var selected = [];        // [{ id, handle, title, price(cents), image, qty }]
    var jsCache = {};         // handle -> product .js
    var current = null;
    var popularCards = [];
    root.querySelectorAll('.bb-bp[data-popular]').forEach(function (c) {
      if (!c.dataset.handle) return;
      if (c.dataset.variant) popularCards.push({ id: String(c.dataset.variant), handle: c.dataset.handle, title: c.dataset.title || '', price: parseInt(c.dataset.price, 10) || 0, image: c.dataset.img || '', cat: c.dataset.cat || '' });
    });

    /* ---- savings tiers ladder ---- */
    /* F17 — four tier states via classes (calculations untouched): is-reached (achieved),
       is-current (highest achieved), is-next (the ONE next unlockable tier — green shimmer +
       lock shake target), is-max (last tier achieved → MAX SAVINGS). Icons are stacked inline
       SVGs crossfaded by state so lock→unlock is a smooth transition, never a swap-flash. */
    var TIER_SVG_LOCK = '<svg class="bb-tier-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4.5" y="10.2" width="15" height="10" rx="2.2"/><path d="M8 10.2V7.2a4 4 0 0 1 8 0v3"/><path d="M12 14.2v2.4"/><circle cx="12" cy="14" r="0.4" fill="currentColor" stroke-width="1"/></svg>';
    var TIER_SVG_UNLOCK = '<svg class="bb-tier-unlock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4.5" y="10.2" width="15" height="10" rx="2.2"/><path d="M8 10.2V7.2a4 4 0 0 1 7.8-1.3"/><path d="M12 14.2v2.4"/></svg>';
    var TIER_SVG_TROPHY = '<svg class="bb-tier-trophy" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 4h10v5a5 5 0 0 1-10 0z"/><path d="M7 5.5H4.5V7A3.2 3.2 0 0 0 7 10.1M17 5.5h2.5V7A3.2 3.2 0 0 1 17 10.1"/><path d="M12 14v3.2"/><path d="M8.5 20.5h7M10 17.2h4a1 1 0 0 1 1 1v2.3H9v-2.3a1 1 0 0 1 1-1z"/></svg>';
    var TIER_SVG_CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l5 5L19.5 7"/></svg>';
    function buildTiers() {
      if (!tiersWrap) return;
      if (!tiers.length) { tiersWrap.hidden = true; return; }
      tiersWrap.hidden = false;
      tiersWrap.style.setProperty('--bb-tier-n', tiers.length);
      var maxFallback = root.dataset.maxFallback || '';
      tiersWrap.innerHTML = '<p class="bb-bundle__tiers-label">The more you add, the more you save</p><ol class="bb-bundle__tiers-row">' + tiers.map(function (t, i) {
        var unit = basis === 'amount' ? fmt(t.min * 100) : (t.min + '+ item' + (t.min === 1 ? '' : 's'));
        var maxLine = (t.max && String(t.max).length) ? t.max : maxFallback;
        var isLast = i === tiers.length - 1;
        return '<li class="bb-bundle__tier" data-min="' + t.min + '"' + (isLast ? ' data-last="1"' : '') + '>' +
          '<div class="bb-bundle__tier-main">' +
            '<span class="bb-bundle__tier-pct">' + t.pct + '% off</span>' +
            (t.label ? '<span class="bb-bundle__tier-name">' + esc(t.label) + '</span>' : '') +
            '<span class="bb-bundle__tier-min">' + unit + '</span>' +
            (maxLine ? '<span class="bb-bundle__tier-max">' + esc(maxLine) + '</span>' : '') +
            (isLast ? '<span class="bb-bundle__tier-maxwrap"><span class="bb-bundle__tier-maxlabel">MAX SAVINGS</span><span class="bb-bundle__tier-maxsub">You unlocked our best bundle discount.</span></span>' : '') +
          '</div>' +
          '<span class="bb-bundle__tier-sep" aria-hidden="true"></span>' +
          '<div class="bb-bundle__tier-ic" aria-hidden="true">' +
            '<span class="bb-bundle__tier-lockwrap">' + TIER_SVG_LOCK + TIER_SVG_UNLOCK + (isLast ? TIER_SVG_TROPHY : '') + '</span>' +
            '<span class="bb-bundle__tier-check">' + TIER_SVG_CHECK + '</span>' +
          '</div>' +
          '</li>';
      }).join('') + '</ol>';
    }
    function updateTiersState(m) {
      if (!tiersWrap) return;
      var nextFound = false;
      var lis = tiersWrap.querySelectorAll('.bb-bundle__tier');
      var highestReached = null;
      lis.forEach(function (li) { if (m >= (parseFloat(li.dataset.min) || 0)) highestReached = li; });
      lis.forEach(function (li) {
        var reached = m >= (parseFloat(li.dataset.min) || 0);
        li.classList.toggle('is-reached', reached);
        li.classList.toggle('is-current', reached && li === highestReached);
        var isNext = !reached && !nextFound;
        if (isNext) nextFound = true;
        li.classList.toggle('is-next', isNext);
        var isMax = reached && li.dataset.last === '1';
        var wasMax = li.classList.contains('is-max');
        li.classList.toggle('is-max', isMax);
        /* one-time celebration pop the first time 5% is reached in this session; removing
           products clears the flag so a genuine re-achievement may pop once again */
        if (isMax && !wasMax) {
          li.classList.add('bb-max-pop');
          setTimeout(function () { li.classList.remove('bb-max-pop'); }, 900);
        }
      });
    }

    /* ---- tiers + totals ---- */
    function tierFor(count, cents) { var m = basis === 'amount' ? cents / 100 : count; var match = null; tiers.forEach(function (t) { if (m >= t.min) match = t; }); return match; }
    function nextTier(count, cents) { var m = basis === 'amount' ? cents / 100 : count; for (var i = 0; i < tiers.length; i++) { if (m < tiers[i].min) return tiers[i]; } return null; }
    function updateTotals() {
      var types = selected.length, qty = 0, cents = 0;
      selected.forEach(function (s) { qty += s.qty; cents += s.price * s.qty; });
      if (el.count) el.count.textContent = types;
      if (el.qty) el.qty.textContent = qty;
      if (el.sub) el.sub.textContent = fmt(cents);
      current = tierFor(qty, cents);
      var discCents = current ? Math.round(cents * current.pct / 100) : 0;
      if (el.discRow) {
        if (current) { el.discRow.hidden = false; if (el.discLabel) el.discLabel.textContent = 'Bundle discount (−' + current.pct + '%)'; if (el.disc) el.disc.textContent = '−' + fmt(discCents); }
        else el.discRow.hidden = true;
      }
      if (el.total) el.total.textContent = fmt(cents - discCents);
      if (el.barCount) el.barCount.textContent = qty;
      if (el.barTotal) el.barTotal.textContent = fmt(cents - discCents);
      updateTiersState(basis === 'amount' ? cents / 100 : qty);
      if (root.classList) root.classList.toggle('bb-bundle--has', qty > 0);
      /* body flag while the mobile sheet-bar is peeking: page content + the mobile menu drawer get
         bottom clearance (CSS in bb-custom.css) so nothing is trapped under the fixed bar */
      if (document.body) document.body.classList.toggle('bb-bundle-sticky-active', qty > 0);
      if (el.nudge) {
        var nt = nextTier(qty, cents);
        if (nt && qty > 0) { var more = basis === 'amount' ? (fmt((nt.min * 100) - cents) + ' more') : ((nt.min - qty) + ' more item' + ((nt.min - qty) === 1 ? '' : 's')); el.nudge.hidden = false; el.nudge.textContent = 'Add ' + more + ' to unlock ' + nt.pct + '% off'; }
        else el.nudge.hidden = true;
      }
      if (el.add) el.add.disabled = qty === 0;
    }
    function renderBundle() {
      if (selWrap) {
        /* Pass 2E: per-product bundle pricing — when a tier is reached, each selected item shows
           its original price struck through and its estimated bundle price. DISPLAY ONLY: the
           real discount still comes from the BUNDLE3–6 code applied at checkout. */
        var pQty = 0, pCents = 0;
        selected.forEach(function (s) { pQty += s.qty; pCents += s.price * s.qty; });
        var pTier = tierFor(pQty, pCents);
        selWrap.innerHTML = selected.map(function (s, i) {
          var line = s.price * s.qty;
          var priceHTML;
          if (pTier) {
            var bp = Math.round(line * (100 - pTier.pct) / 100);
            priceHTML = '<span class="bb-sel__price bb-sel__price--deal"><s>' + fmt(line) + '</s> <b>' + fmt(bp) + '</b><span class="bb-sel__bp">Bundle price</span></span>';
          } else {
            priceHTML = '<span class="bb-sel__price">' + fmt(line) + '</span>';
          }
          return '<div class="bb-sel" data-i="' + i + '">' +
            '<span class="bb-sel__media">' + (s.image ? '<img src="' + esc(s.image) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="bb-sel__info"><span class="bb-sel__title">' + esc(s.title) + '</span>' + priceHTML + '</span>' +
            '<span class="bb-sel__qty"><button type="button" data-bb-dec aria-label="Decrease quantity">&minus;</button><span class="bb-sel__qval">' + s.qty + '</span><button type="button" data-bb-inc aria-label="Increase quantity">+</button></span>' +
            '<button type="button" class="bb-sel__rm" data-bb-rm aria-label="Remove">&times;</button>' +
          '</div>';
        }).join('');
      }
      if (emptySel) emptySel.hidden = selected.length > 0;
      updateTotals();
      renderRecs();
      syncCards();
    }
    /* ---- persistent selected state on cards ---- */
    function syncCards() {
      var byHandle = {}; selected.forEach(function (s) { if (s.handle) byHandle[s.handle] = (byHandle[s.handle] || 0) + s.qty; });
      root.querySelectorAll('.bb-bp[data-handle]').forEach(function (c) {
        var n = byHandle[c.dataset.handle] || 0;
        c.classList.toggle('is-selected', n > 0);
        var btn = c.querySelector('[data-bb-add]');
        if (btn && !btn.disabled) { btn.classList.toggle('is-added', n > 0); btn.textContent = n > 0 ? ('Added' + (n > 1 ? ' · ' + n : '')) : 'Add'; }
      });
    }
    function recHint(c) {
      var qty = 0, cents = 0; selected.forEach(function (s) { qty += s.qty; cents += s.price * s.qty; });
      var ntNow = nextTier(qty, cents);
      var hint = '+' + fmt(c.price);
      if (ntNow) { var reach = basis === 'amount' ? ((cents + c.price) / 100 >= ntNow.min) : (qty + 1 >= ntNow.min); if (reach) hint = 'Unlocks ' + ntNow.pct + '% off'; }
      return hint;
    }
    function recRowHTML(c) {
      return '<div class="bb-rec" data-variant="' + esc(c.id) + '" data-handle="' + esc(c.handle) + '" data-price="' + c.price + '" data-title="' + esc(c.title) + '" data-img="' + esc(c.image) + '">' +
        '<span class="bb-rec__media">' + (c.image ? '<img src="' + esc(c.image) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="bb-rec__info"><span class="bb-rec__title">' + esc(c.title) + '</span><span class="bb-rec__hint">' + recHint(c) + '</span></span>' +
        '<button type="button" class="bb-rec__add" data-bb-rec-add aria-label="Add">+</button></div>';
    }

    /* Pass 2E — Recommended Next: with a dedicated collection set, three slots rotate through it
       vertically (slow slot-machine). Selection-aware, pause on hover/focus, reduced-motion safe.
       Adds through the exact same addItem path, so bundle discounts are untouched. */
    var recsPool = [];
    try {
      var poolEl = root.querySelector('[data-bundle-recs-pool]');
      if (poolEl) recsPool = JSON.parse(poolEl.textContent || '[]');
    } catch (e) { recsPool = []; }
    var slotState = { idx: [0, 1, 2], next: 0, paused: false, timer: null };
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function recAvailable() {
      var have = {}; selected.forEach(function (s) { have[s.id] = true; });
      return recsPool.filter(function (c) { return !have[c.id]; });
    }
    function renderSlots(initial) {
      var avail = recAvailable();
      if (!avail.length) { recsWrap.hidden = true; recsList.innerHTML = ''; return; }
      recsWrap.hidden = false;
      recsList.classList.add('bb-recs--slots');
      var n = Math.min(3, avail.length);
      if (initial || recsList.children.length !== n) {
        slotState.idx = [];
        recsList.innerHTML = '';
        for (var i = 0; i < n; i++) {
          slotState.idx.push(i % avail.length);
          var slot = document.createElement('div');
          slot.className = 'bb-rec-slot';
          slot.innerHTML = recRowHTML(avail[i % avail.length]);
          recsList.appendChild(slot);
        }
      } else {
        [].forEach.call(recsList.children, function (slot, i) {
          var c = avail[slotState.idx[i] % avail.length];
          if (c) slot.innerHTML = recRowHTML(c);
        });
      }
    }
    function spinOneSlot() {
      if (slotState.paused || document.hidden) return;
      var avail = recAvailable();
      if (avail.length <= 3) return; // nothing new to rotate in
      var slots = recsList.children;
      if (!slots.length) return;
      var i = slotState.next % slots.length;
      slotState.next++;
      // pick the next pool item not currently shown in any slot
      var shown = {}; slotState.idx.forEach(function (x) { var c = avail[x % avail.length]; if (c) shown[c.id] = true; });
      var start = (slotState.idx[i] + 1) % avail.length, pick = start;
      for (var k = 0; k < avail.length; k++) { var cand = (start + k) % avail.length; if (!shown[avail[cand].id]) { pick = cand; break; } }
      slotState.idx[i] = pick;
      var slot = slots[i];
      slot.classList.add('is-out');
      setTimeout(function () {
        slot.innerHTML = recRowHTML(avail[pick % avail.length]);
        slot.classList.remove('is-out');
        slot.classList.add('is-in');
        setTimeout(function () { slot.classList.remove('is-in'); }, 460);
      }, 300);
    }
    if (recsPool.length && recsWrap && recsList) {
      var stepMs = Math.max(2.5, parseFloat(recsList.dataset.recsSpeed || '5')) * 1000;
      recsWrap.addEventListener('mouseenter', function () { slotState.paused = true; });
      recsWrap.addEventListener('mouseleave', function () { slotState.paused = false; });
      recsWrap.addEventListener('focusin', function () { slotState.paused = true; });
      recsWrap.addEventListener('focusout', function () { slotState.paused = false; });
      if (!reduceMotion) slotState.timer = setInterval(spinOneSlot, stepMs);
    }

    function renderRecs() {
      if (!recsWrap || !recsList) return;
      if (recsPool.length) { renderSlots(false); return; }
      var have = {}; selected.forEach(function (s) { have[s.id] = true; });
      var picks = popularCards.filter(function (c) { return !have[c.id]; }).slice(0, 3);
      if (!picks.length) { recsWrap.hidden = true; recsList.innerHTML = ''; return; }
      recsWrap.hidden = false;
      recsList.innerHTML = picks.map(recRowHTML).join('');
    }
    if (recsPool.length && recsWrap && recsList) renderSlots(true);
    function addItem(item) {
      if (!item || !item.id) return;
      var ex = null; for (var i = 0; i < selected.length; i++) { if (selected[i].id === item.id) { ex = selected[i]; break; } }
      if (ex) ex.qty += 1; else selected.push({ id: item.id, handle: item.handle, title: item.title, price: item.price, image: item.image, qty: 1 });
      renderBundle();
    }

    function addByCard(card) {
      if (!card || card.classList.contains('is-out')) return;
      var btn = card.querySelector('[data-bb-add]');
      /* F187 — a picker on the card means the shopper's choice is the ONLY valid source of the
         variant id. Checked before data-variant so the ordering can never regress: a card with a
         picker is precisely the card that must not fall back. */
      var sel = card.querySelector('[data-bb-variant]');
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (!sel.value || !opt) { try { sel.focus(); } catch (e) {} return; }
        addItem({
          id: String(sel.value),
          handle: card.dataset.handle,
          /* the variant is in the line title so two variants of one product are distinguishable
             in the build list, which dedupes by variant id and would otherwise show two
             identical rows. */
          title: (card.dataset.title || '') + ' \u2014 ' + (opt.getAttribute('data-vtitle') || opt.textContent || ''),
          price: parseInt(opt.getAttribute('data-price'), 10) || 0,
          image: card.dataset.img || ''
        });
        return;
      }
      if (card.dataset.variant) { addItem({ id: String(card.dataset.variant), handle: card.dataset.handle, title: card.dataset.title || '', price: parseInt(card.dataset.price, 10) || 0, image: card.dataset.img || '' }); return; }
      var handle = card.dataset.handle; if (!handle) return;
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      function finish(prod) {
        if (btn) btn.disabled = false;
        if (!prod || !prod.variants || !prod.variants.length) { if (btn) btn.textContent = 'Unavailable'; return; }
        var v = prod.variants.filter(function (x) { return x.available; })[0] || prod.variants[0];
        if (!v) { if (btn) btn.textContent = 'Unavailable'; return; }
        addItem({ id: String(v.id), handle: handle, title: prod.title, price: v.price, image: prod.featured_image || (prod.images && prod.images[0]) || card.dataset.img || '' });
      }
      if (jsCache[handle]) { finish(jsCache[handle]); return; }
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (prod) { jsCache[handle] = prod; finish(prod); }).catch(function () { finish(null); });
    }

    if (results) results.addEventListener('click', function (e) { var b = e.target.closest('[data-bb-add]'); if (!b) return; e.preventDefault(); var card = b.closest('.bb-bp'); if (card) addByCard(card); });
    /* F187 — one delegated change handler for both the Liquid cards and the JS-appended ones,
       so hydrated cards need no re-binding. It owns two things: the displayed price and the Add
       gate. The pre-selection label ("From $37.99") is stashed on first change so backing out to
       the placeholder restores it exactly rather than leaving the last variant's price showing
       next to a disabled button. */
    if (results) results.addEventListener('change', function (e) {
      var sel = e.target && e.target.closest ? e.target.closest('[data-bb-variant]') : null;
      if (!sel) return;
      var card = sel.closest('.bb-bp'); if (!card) return;
      var priceEl = card.querySelector('.bb-bp__price');
      var btn = card.querySelector('[data-bb-add]');
      if (priceEl && !priceEl.dataset.bbFrom) priceEl.dataset.bbFrom = priceEl.textContent.trim();
      var opt = sel.options[sel.selectedIndex];
      if (sel.value && opt) {
        if (priceEl) priceEl.textContent = fmt(parseInt(opt.getAttribute('data-price'), 10) || 0);
        if (btn) btn.disabled = false;
      } else {
        if (priceEl) priceEl.textContent = priceEl.dataset.bbFrom || priceEl.textContent;
        if (btn) btn.disabled = true;
      }
      /* re-label the (now enabled) button to Add / Added · N for this handle */
      syncCards();
    });
    if (selWrap) selWrap.addEventListener('click', function (e) {
      var row = e.target.closest('.bb-sel'); if (!row) return; var i = parseInt(row.dataset.i, 10); if (isNaN(i) || !selected[i]) return;
      if (e.target.closest('[data-bb-inc]')) selected[i].qty += 1;
      else if (e.target.closest('[data-bb-dec]')) { selected[i].qty -= 1; if (selected[i].qty < 1) selected.splice(i, 1); }
      else if (e.target.closest('[data-bb-rm]')) selected.splice(i, 1);
      else return;
      renderBundle();
    });

    /* ---- collapsible mobile sheet + back-to-builder (Pass 2E) ---- */
    var backBtn = root.querySelector('[data-bundle-back]');
    function setSheet(open) {
      if (!summary) return;
      summary.classList.toggle('is-open', open);
      if (sheetBtn) sheetBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (backBtn) backBtn.hidden = !open;
      /* Ryan: the bar reads "Review Build" when closed, "Hide Build" when the sheet is open */
      var sheetLabel = root.querySelector('[data-bundle-sheet-label]');
      if (sheetLabel) sheetLabel.textContent = open ? (root.dataset.sheetHide || 'Hide Build') : (root.dataset.sheetReview || 'Review Build');
    }
    if (sheetBtn && summary) sheetBtn.addEventListener('click', function () {
      setSheet(!summary.classList.contains('is-open'));
    });
    if (backBtn) backBtn.addEventListener('click', function () { setSheet(false); });

    /* ============================================================
       Model (one collection per model) -> search all parts.
       Category filters removed (Ryan). Liquid renders each valid model's first 50 products
       (Liquid's for-loop cap); on model select the FULL collection is fetched via the public
       /collections/<handle>/products.json endpoint (250/page, paged) and the remainder is appended as
       JS cards — the pager and search always cover the whole collection in Shopify order. Search
       filters the active model's cards in place (title / handle / type / tags / vendor, case-
       insensitive); clearing restores collection order. A stale fetch can never overwrite a newer
       model selection (modelSeq guard).
       ============================================================ */
    var promptEl = root.querySelector('[data-bundle-prompt]');
    var clearSearchBtn = root.querySelector('[data-bundle-clearsearch]');
    var countD = parseInt(root.dataset.countD, 10) || 10;
    var countM = parseInt(root.dataset.countM, 10) || 8;
    var mqMobile = window.matchMedia('(max-width: 749px)');
    function activeLimit() { return mqMobile.matches ? countM : countD; }
    var pageStart = 0;
    var pager = root.querySelector('[data-bundle-pager]');
    var pgPrev = root.querySelector('[data-bundle-pgprev]');
    var pgNext = root.querySelector('[data-bundle-pgnext]');
    var pgInfo = root.querySelector('[data-bundle-pginfo]');
    var activeGroup = null;
    var query = '';
    var modelSeq = 0;

    function cardHTML(p) {
      var img = p.image || ''; var avail = p.available !== false; var type = p.product_type || '';
      /* F17: JS-appended cards mirror the Liquid card's shipping pill. The public products.json
         feed exposes availability but not metafields, so this is availability-gated only — the
         (rare) metafield-overridden product would simply match the PDP default here. */
      /* F22: mirror of snippets/bb-is-lighting.liquid for JS-built cards — lighting products
         get the lighting label ("Free Shipping"). Rules 2-4 (tag / type / trigger words) are
         reproducible from products.json; the metafield-only case falls back to the same
         trigger words, matching the Liquid card in practice. */
      var isLight = false;
      (function () {
        var tags = String(p.tags || '').toLowerCase();
        var tagList = tags.split(/[,\s]+/);
        if (tagList.indexOf('lighting') > -1 || /:lighting(\s|,|$)/.test(tags)) { isLight = true; return; }
        if (String(p.product_type || '').toLowerCase().indexOf('light') > -1) { isLight = true; return; }
        var hay = (String(p.title || '') + ' ' + String(p.product_type || '') + ' ' + tags).toLowerCase();
        var trigs = (root.dataset.lightTrigs || '').split(',');
        for (var ti = 0; ti < trigs.length; ti++) {
          var tt = trigs[ti].trim().toLowerCase();
          if (tt && hay.indexOf(tt) > -1) { isLight = true; return; }
        }
      })();
      /* F22b (Ryan): keep the shipping pill ONLY for lighting products ("Free Shipping");
         non-lighting "Ships Next-Day" bubbles are removed. Mirrors the Liquid card gate. */
      var shipText = root.dataset.lightText || 'Free Shipping';
      var shipHTML = (avail && isLight && shipText) ? '<span class="bb-bp__ship"><svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 7.5A1.5 1.5 0 0 1 3.5 6H14v10H3.5A1.5 1.5 0 0 1 2 14.5z"/><path d="M14 9h3.6l2.4 2.6V16H14z"/><circle cx="6.5" cy="18" r="1.7"/><circle cx="17" cy="18" r="1.7"/></svg>' + esc(shipText) + '</span>' : '';
      /* F187 — mirror of the picker in snippets/bb-bundle-card.liquid. Same classes, same
         data-bb-variant hook, same "no data-variant when multi" rule, so one click handler and
         one change handler serve both halves of the grid and they cannot drift apart. */
      var vars = Array.isArray(p.variants) ? p.variants : [];
      var multi = vars.length > 1;
      var varHTML = '';
      var priceLabel = avail ? esc(p.price || '') : 'Sold out';
      if (multi && avail) {
        var live = vars.filter(function (vv) { return vv.available; });
        var basis = live.length ? live : vars;
        var lo = Math.min.apply(null, basis.map(function (vv) { return vv.priceCents || 0; }));
        var hi = Math.max.apply(null, basis.map(function (vv) { return vv.priceCents || 0; }));
        priceLabel = (lo === hi) ? fmt(lo) : ('From ' + fmt(lo));
        varHTML = '<select class="bb-bp__var" data-bb-variant aria-label="Choose an option for ' + esc(p.title) + '">' +
          '<option value="" selected>Options</option>' +
          vars.map(function (vv) {
            return '<option value="' + esc(vv.id) + '" data-price="' + (vv.priceCents || 0) + '" data-vtitle="' + esc(vv.title) + '"' +
              (vv.available ? '' : ' disabled') + '>' + esc(vv.title) + (vv.available ? '' : ' \u2014 Sold out') + '</option>';
          }).join('') + '</select>';
      }
      return '<article class="bb-bp' + (avail ? '' : ' is-out') + '" data-handle="' + esc(p.handle) + '" data-title="' + esc(p.title) + '" data-img="' + esc(img) + '" data-cat="' + esc(((type + ' ' + (p.tags || '')).toLowerCase())) + '" data-vendor="' + esc((p.vendor || '').toLowerCase()) + '"' + (!multi && p.variantId ? ' data-variant="' + esc(p.variantId) + '" data-price="' + (p.priceCents || 0) + '"' : '') + '>' +
        '<a class="bb-bp__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" width="120" height="120" loading="lazy" alt="">' : '<span class="bb-bp__ph"></span>') + shipHTML + '</a>' +
        '<div class="bb-bp__body">' + (type ? '<span class="bb-bp__type">' + esc(type) + '</span>' : '') +
        '<h4 class="bb-bp__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h4>' +
        varHTML +
        '<div class="bb-bp__foot"><span class="bb-bp__price">' + priceLabel + '</span>' +
        '<button type="button" class="bb-bp__add" data-bb-add' + (avail && !multi ? '' : ' disabled') + '>' + (avail ? 'Add' : 'Sold out') + '</button></div></div></article>';
    }
    function matchesQuery(c) {
      if (!query) return true;
      var hay = ((c.dataset.title || '') + ' ' + (c.dataset.handle || '') + ' ' + (c.dataset.cat || '') + ' ' + (c.dataset.vendor || '')).toLowerCase();
      return hay.indexOf(query) !== -1;
    }
    function showPage() {
      var lim = activeLimit();
      if (!activeGroup) { if (pager) pager.hidden = true; if (noResults) noResults.hidden = true; return; }
      var matching = [];
      activeGroup.querySelectorAll('.bb-bp').forEach(function (c) {
        var m = matchesQuery(c);
        c.hidden = true;
        if (m) matching.push(c);
      });
      if (pageStart >= matching.length) pageStart = 0;
      matching.slice(pageStart, pageStart + lim).forEach(function (c) { c.hidden = false; });
      /* F46 — show the panel whenever the grid has nothing to offer, not only on a failed
         search: with sold-out parts filtered out, a model can legitimately render zero cards.
         The wording and the Clear-search button follow whichever case it is. */
      if (noResults) {
        var isEmpty = matching.length === 0;
        noResults.hidden = !isEmpty;
        if (isEmpty) {
          var msgEl = noResults.querySelector('[data-bundle-noresults-text]');
          /* F46b — "sold out" is a CLAIM, so only make it once the full product list has actually
             settled. selectModel runs showPage() synchronously and starts the fetch after, so a
             model whose server-rendered window happens to be all sold-out would otherwise assert
             "sold out" while its in-stock parts were still in flight — and permanently so if the
             fetch failed. Pending → neutral loading line; failed → "couldn't load". */
          var pending = needsHydrate(activeGroup) &&
            !activeGroup.dataset.hydrated && !activeGroup.dataset.hydrateFailed;
          var failed = !!activeGroup.dataset.hydrateFailed && !activeGroup.dataset.hydrated;
          if (msgEl) {
            msgEl.textContent = query
              ? (noResults.dataset.nomatch || msgEl.textContent)
              : pending
                ? (noResults.dataset.loading || msgEl.textContent)
                : failed
                  ? (noResults.dataset.loaderr || msgEl.textContent)
                  : (noResults.dataset.nostock || msgEl.textContent);
          }
          var clearBtn = noResults.querySelector('[data-bundle-clearsearch]');
          if (clearBtn) clearBtn.hidden = !query;
        }
      }
      if (pager) {
        var pages = Math.ceil(matching.length / lim) || 1;
        pager.hidden = pages <= 1 || matching.length === 0;
        var page = Math.floor(pageStart / lim) + 1;
        if (pgInfo) pgInfo.textContent = page + ' / ' + pages;
        if (pgPrev) pgPrev.disabled = pageStart <= 0;
        if (pgNext) pgNext.disabled = pageStart + lim >= matching.length;
      }
    }
    function pageBy(dir) {
      var lim = activeLimit();
      pageStart = Math.max(0, pageStart + dir * lim);
      showPage();
      syncCards();
    }
    if (pgPrev) pgPrev.addEventListener('click', function () { pageBy(-1); });
    if (pgNext) pgNext.addEventListener('click', function () { pageBy(1); });
    if (recsList) recsList.addEventListener('click', function (e) { var b = e.target.closest('[data-bb-rec-add]'); if (!b) return; var row = b.closest('.bb-rec'); if (!row) return; addItem({ id: String(row.dataset.variant), handle: row.dataset.handle, title: row.dataset.title, price: parseInt(row.dataset.price, 10) || 0, image: row.dataset.img }); });

    /* full-collection fetch: appends products 51+ as JS cards, in collection order */
    /* F46b — does this group still have products the Liquid loop never reached? Gate on the loop
       CAP, not on the rendered-card count: data-total counts SOLD-OUT products too, so once they
       stopped rendering, `total <= rendered` was false for nearly every group and each one fired a
       full 250-item products.json round trip that could only return items already on screen. The
       loop scanned min(cap, total) products, so anything missing exists only when total > cap. */
    function needsHydrate(group) {
      var total = parseInt(group.getAttribute('data-total'), 10) || 0;
      var cap = parseInt(group.getAttribute('data-cap'), 10) || 50;
      return total > cap;
    }
    function hydrateGroup(group, my) {
      var handle = group.getAttribute('data-handle');
      if (!handle || !needsHydrate(group) || group.dataset.hydrated) return;
      group.dataset.hydrating = '1';
      var all = [];
      (function page(n) {
        fetch('/collections/' + handle + '/products.json?limit=250&page=' + n, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
          .then(function (data) {
            if (my !== modelSeq) { delete group.dataset.hydrating; return; }
            var items = (data && data.products) || [];
            items.forEach(function (p) {
              var v = (p.variants && p.variants[0]) || null;
              var anyAvail = p.variants ? p.variants.some(function (vv) { return vv.available; }) : true;
              /* F187 — the feed already HAD every variant and threw them away on the line above,
                 which is why the JS-rendered half of the grid could not offer a picker either.
                 products.json gives price as a decimal string ("37.99"), so normalise to cents
                 here, once, in the same units the Liquid card emits and fmt() consumes. */
              var vlist = (p.variants || []).map(function (vv) {
                return {
                  id: String(vv.id),
                  title: vv.title || '',
                  priceCents: Math.round(parseFloat(vv.price) * 100) || 0,
                  available: vv.available !== false
                };
              });
              /* F46 — mirrors the Liquid grid: sold-out parts are never offered in the builder.
                 This is the ONLY other place products enter the grid, so filtering both keeps
                 search and paging consistent with the first 50 Liquid-rendered cards. */
              if (!anyAvail) return;
              all.push({
                handle: p.handle, title: p.title, url: '/products/' + p.handle,
                image: (p.images && p.images[0] && p.images[0].src) || '',
                product_type: p.product_type || '', vendor: p.vendor || '',
                tags: Array.isArray(p.tags) ? p.tags.join(' ') : String(p.tags || ''),
                available: anyAvail,
                variants: vlist,
                /* single-variant only: cardHTML withholds these on a multi-variant product for the
                   same reason the Liquid card does. */
                variantId: vlist.length === 1 && v ? String(v.id) : '',
                priceCents: v ? Math.round(parseFloat(v.price) * 100) : 0,
                price: v ? fmt(Math.round(parseFloat(v.price) * 100)) : ''
              });
            });
            if (items.length === 250) { page(n + 1); return; }
            if (my !== modelSeq) { delete group.dataset.hydrating; return; }
            var have = {};
            group.querySelectorAll('.bb-bp').forEach(function (c) { have[c.dataset.handle] = true; });
            var extra = all.filter(function (p) { return !have[p.handle]; });
            group.dataset.hydrated = '1';
            delete group.dataset.hydrating;
            if (extra.length) {
              group.querySelector('.bb-bundle__grid').insertAdjacentHTML('beforeend', extra.map(cardHTML).join(''));
              syncCards();
            }
            /* always re-run: even with nothing to append, the empty-state wording depends on
               hydration having settled (see showPage) */
            showPage();
          })
          .catch(function () {
            /* endpoint unavailable: the server-rendered products remain browsable/searchable.
               F46b — mark the failure so the empty state says "couldn't load" instead of
               claiming the model is sold out, which would be a lie we could never take back. */
            delete group.dataset.hydrating;
            group.dataset.hydrateFailed = '1';
            showPage();
          });
      })(1);
    }

    function selectModel(blockId) {
      var my = ++modelSeq;
      pageStart = 0;
      query = '';
      if (search) search.value = '';
      if (clearBtn) clearBtn.hidden = true;
      groups.forEach(function (g) { g.hidden = g.getAttribute('data-bundle-group') !== blockId; });
      activeGroup = blockId ? root.querySelector('[data-bundle-group="' + blockId + '"]') : null;
      if (promptEl) promptEl.hidden = !!activeGroup;
      if (defaultWrap) defaultWrap.hidden = !activeGroup;
      if (noResults) noResults.hidden = true;
      showPage();
      syncCards();
      if (activeGroup) hydrateGroup(activeGroup, my);
    }
    if (modelSel) modelSel.addEventListener('change', function () { selectModel(modelSel.value); });

    /* ---- F88: custom model dropdown (proxies the native select) ---- */
    (function () {
      var wrap = root.querySelector('.bb-bundle__carselect');
      var trig = root.querySelector('[data-bundle-mtrig]');
      var list = root.querySelector('[data-bundle-mlist]');
      var label = root.querySelector('[data-bundle-mtrig-label]');
      if (!wrap || !trig || !list || !label || !modelSel) return;
      var open = false, activeIdx = -1, rows = [];
      // build rows from the select's real options (placeholder stays trigger-label only)
      for (var i = 0; i < modelSel.options.length; i++) {
        var o = modelSel.options[i];
        if (o.disabled) continue;
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.dataset.value = o.value;
        li.textContent = o.text;
        list.appendChild(li);
        rows.push(li);
      }
      if (!rows.length) return; // nothing to pick — leave the native select alone
      wrap.classList.add('is-custom');
      trig.hidden = false;
      function setOpen(v) {
        open = v;
        trig.setAttribute('aria-expanded', v ? 'true' : 'false');
        if (v) {
          list.hidden = false;
          /* rAF is suppressed in hidden/background tabs (F76) — arm the entry class either way,
             guarded on `open` so a fast close can't resurrect the class on a hidden list */
          requestAnimationFrame(function () { if (open) list.classList.add('is-open'); });
          setTimeout(function () { if (open) list.classList.add('is-open'); }, 60);
          activeIdx = rows.findIndex(function (r) { return r.getAttribute('aria-selected') === 'true'; });
        } else {
          list.classList.remove('is-open');
          list.hidden = true; // instant hide keeps outside-click + Escape snappy; the entry animates
          rows.forEach(function (r) { r.classList.remove('is-active'); });
        }
      }
      function choose(li) {
        rows.forEach(function (r) { r.removeAttribute('aria-selected'); });
        li.setAttribute('aria-selected', 'true');
        label.textContent = li.textContent;
        modelSel.value = li.dataset.value;
        // the ONE bridge into all existing logic — selectModel() runs from this exact event
        modelSel.dispatchEvent(new Event('change', { bubbles: true }));
        setOpen(false);
        trig.focus();
      }
      trig.addEventListener('click', function () { setOpen(!open); });
      list.addEventListener('click', function (e) {
        var li = e.target.closest('li[role="option"]');
        if (li) choose(li);
      });
      document.addEventListener('pointerdown', function (e) {
        if (open && !wrap.contains(e.target)) setOpen(false);
      });
      trig.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); if (!open) setOpen(true); move(e.key === 'ArrowDown' ? 1 : -1); }
        else if (e.key === 'Escape' && open) { e.preventDefault(); setOpen(false); }
        else if ((e.key === 'Enter' || e.key === ' ') && open && activeIdx >= 0) { e.preventDefault(); choose(rows[activeIdx]); }
      });
      function move(d) {
        activeIdx = Math.max(0, Math.min(rows.length - 1, activeIdx + d));
        rows.forEach(function (r, i) { r.classList.toggle('is-active', i === activeIdx); });
        if (rows[activeIdx]) rows[activeIdx].scrollIntoView({ block: 'nearest' });
      }
    })();

    /* search = live filter within the selected model's full collection */
    var timer = null;
    if (search) search.addEventListener('input', function () {
      var q = search.value.trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { query = q.toLowerCase(); pageStart = 0; showPage(); syncCards(); }, 160);
    });
    function clearSearch() {
      if (search) { search.value = ''; search.focus(); }
      if (clearBtn) clearBtn.hidden = true;
      query = ''; pageStart = 0; showPage(); syncCards();
    }
    if (clearBtn) clearBtn.addEventListener('click', clearSearch);
    if (clearSearchBtn) clearSearchBtn.addEventListener('click', clearSearch);

    /* ---- add bundle to cart ---- */
    if (el.add) el.add.addEventListener('click', function () {
      if (!selected.length) return;
      var orig = el.add.textContent; el.add.disabled = true; el.add.textContent = 'Adding…';
      var code = current && current.code ? current.code : null;
      /* F87 — stamp every line the builder adds. This is the ONLY thing that distinguishes a real
         Bundle Builder bundle from four items someone happened to put in the cart, and the cart
         guard reads it to decide whether a BUNDLE code is allowed to stay attached. The leading
         underscore keeps it hidden from the customer and from checkout, same as the TackOn
         _priceInCent property already in this store. */
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: selected.map(function (s) { return { id: s.id, quantity: s.qty, properties: { _bb_bundle: '1' } }; }) }) })
        .then(function (r) {
          /* a 422 (sold out / quantity cap) must NOT fall through to the discount redirect with a
             half-empty cart — surface it and let the customer retry */
          if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'Add failed'); });
          return r.json();
        })
        .then(function () { window.location.href = code ? ('/discount/' + encodeURIComponent(code) + '?redirect=/cart') : '/cart'; })
        .catch(function () { el.add.disabled = false; el.add.textContent = 'Couldn’t add — try again'; setTimeout(function () { el.add.textContent = orig; }, 2600); });
    });

    buildTiers();
    renderBundle();
    /* legacy single-collection mode boots straight into its group; vehicle mode waits for a model pick */
    if (root.querySelector('[data-bundle-group="legacy"]')) selectModel('legacy');
    var wasMobile = mqMobile.matches;
    window.addEventListener('resize', function () {
      if (mqMobile.matches !== wasMobile) { wasMobile = mqMobile.matches; pageStart = 0; showPage(); syncCards(); }
    });
  }
  /* F27 — the sheet stays visibility:hidden until bb-bundle--init lands; the double-rAF lets
     the initial --has state settle first so the sheet can never animate on first paint. */
  function initGuarded(el) {
    init(el);
    var arm = function () { el.classList.add('bb-bundle--init'); };
    requestAnimationFrame(function () { requestAnimationFrame(arm); });
    setTimeout(arm, 300); /* rAF is suppressed in hidden/background tabs — arm either way */
  }
  document.querySelectorAll('[data-bb-bundle]').forEach(initGuarded);
  document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-bb-bundle]'); if (el) initGuarded(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-hero-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.customElements && customElements.get('bb-hero-carousel')) return;

  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  class BBHeroCarousel extends HTMLElement {
    connectedCallback() {
      if (this.__bbInit) return;
      this.__bbInit = true;

      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-bb-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-bb-dot]'));
      this.live = this.querySelector('[data-bb-live]');
      this.frame = this.querySelector('.bb-hspot__frame');
      this.count = this.slides.length;
      this.index = 0;
      this.timer = 0;
      this.resumeTimer = 0;
      this.interacting = false;

      this.interval = parseInt(this.getAttribute('data-interval'), 10) || 6000;
      this.tdur = parseInt(this.getAttribute('data-transition'), 10) || 700;
      this.pauseOnInteract = this.hasAttribute('data-pause-interaction');

      this._bindArtDirection();
      this.autoplayOn = this.hasAttribute('data-autoplay') && this.count > 1 && !RM.matches;

      this.classList.add('is-ready');
      this._sync(0, -1);

      var self = this;
      var prevBtn = this.querySelector('[data-bb-prev]');
      var nextBtn = this.querySelector('[data-bb-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { self.prev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { self.next(); });
      this.dots.forEach(function (d) {
        d.addEventListener('click', function () { self.goTo(parseInt(d.getAttribute('data-index'), 10), true); });
      });

      this._onKey = function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.prev(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); self.next(); }
      };
      this.addEventListener('keydown', this._onKey);

      if (this.count > 1) {
        if (this.pauseOnInteract) {
          this._onEnter = function () { self.interacting = true; self._stop(); };
          this._onLeave = function () { self.interacting = false; self._deferResume(); };
          this._onFocusIn = function () { self.interacting = true; self._stop(); };
          this._onFocusOut = function () { setTimeout(function () { if (!self.contains(document.activeElement)) { self.interacting = false; self._deferResume(); } }, 0); };
          this.addEventListener('mouseenter', this._onEnter);
          this.addEventListener('mouseleave', this._onLeave);
          this.addEventListener('focusin', this._onFocusIn);
          this.addEventListener('focusout', this._onFocusOut);
        }
        this._initSwipe();
        this._onVis = function () {
          if (document.hidden) { self._stop(); }
          else if (self.autoplayOn && !self.interacting) { self._start(); }
        };
        document.addEventListener('visibilitychange', this._onVis);

        this._onBlockSelect = function (e) {
          var t = e.target && e.target.closest ? e.target.closest('[data-bb-slide]') : null;
          if (!t || !self.contains(t)) return;
          self._stop();
          var idx = self.slides.indexOf(t);
          if (idx > -1) self.goTo(idx, true);
        };
        this._onBlockDeselect = function () { if (self.autoplayOn && !document.hidden) self._deferResume(); };
        this._onSecSelect = function (e) { if (e.target && e.target.contains && e.target.contains(self)) self._stop(); };
        this._onSecDeselect = function (e) { if (e.target && e.target.contains && e.target.contains(self)) { if (self.autoplayOn && !document.hidden) self._deferResume(); } };
        document.addEventListener('shopify:block:select', this._onBlockSelect);
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        document.addEventListener('shopify:section:select', this._onSecSelect);
        document.addEventListener('shopify:section:deselect', this._onSecDeselect);
      }

      // Lift bottom controls above the fold by however far the full-height frame
      // overflows below the viewport at page top (e.g. the announcement-bar offset).
      this._measureLift = function () {
        if (window.scrollY > 4) return;
        var fr = (self.frame || self).getBoundingClientRect();
        var over = Math.round(fr.bottom - window.innerHeight);
        if (over < 0) over = 0;
        if (over > 80) over = 80;
        self.style.setProperty('--bb-ctrl-lift', over + 'px');
      };
      this._onResizeLift = function () { clearTimeout(self.__liftT); self.__liftT = setTimeout(self._measureLift, 120); };
      this._measureLift();
      [140, 600, 1300].forEach(function (t) { setTimeout(self._measureLift, t); });
      window.addEventListener('load', this._measureLift);
      window.addEventListener('resize', this._onResizeLift, { passive: true });

      this._preloadNext(1);
      if (this.autoplayOn && !document.hidden) this._start();
    }

    /* ------------------------------------------------------------------
       ART-DIRECTION REPAIR - the root cause of "mobile shows the desktop hero".

       The markup is correct: <source media="(max-width: 749px)"> names the mobile
       art and the <img> carries the desktop art. The bug is browser behaviour, not
       Liquid. Once an <img> inside a <picture> has SUCCESSFULLY LOADED a candidate,
       browsers do not re-run source selection downward - they keep the larger image
       they already hold. Reproduced live: load at 1440 then narrow to 390 and
       matchMedia('(max-width: 749px)').matches is TRUE while currentSrc is still the
       desktop file on every slide.

       That is exactly why the report was intermittent. It needs any path where the
       page resolves wide and ends up narrow:
         - orientation change (landscape phone is often > 749px, then back to portrait)
         - back/forward restore from bfcache, which replays a page resolved elsewhere
         - a theme-editor section reload while the preview frame is being resized
         - any resize across the breakpoint
       A clean cold load at 390px was always correct, which is why it looked random.

       THE FIX REQUESTS THE REAL ASSET - it does not hide the desktop one. Replacing
       the <picture> with a fresh clone gives the browser no prior resolution to keep,
       so it runs selection again and FETCHES the mobile file. Verified live: both
       slides switched from the desktop files to the mobile files after the swap.

       Only fires when the loaded file genuinely disagrees with the matching <source>,
       so the common case costs nothing and no extra bytes are ever requested.
       ------------------------------------------------------------------ */
    _bindArtDirection() {
      var self = this;
      var base = function (u) { return (u || '').split('/').pop().split('?')[0]; };

      var wrong = function (pic) {
        var img = pic.querySelector('img');
        var src = pic.querySelector('source');
        if (!img || !src || !img.currentSrc) return false;
        var media = src.getAttribute('media');
        if (!media || !window.matchMedia(media).matches) return false;
        return (src.getAttribute('srcset') || '').indexOf(base(img.currentSrc)) === -1;
      };

      this._reselect = function () {
        var pics = self.querySelectorAll('.bb-hspot__pic');
        for (var i = 0; i < pics.length; i++) {
          if (wrong(pics[i])) pics[i].replaceWith(pics[i].cloneNode(true));
        }
      };

      /* rAF-deferred: on a resize or restore the viewport can still be settling, and
         reading currentSrc too early judges against the pre-resize layout. */
      var kick = function () { window.requestAnimationFrame(self._reselect); };

      this._mq = window.matchMedia('(max-width: 749px)');
      this._onMq = kick;
      if (this._mq.addEventListener) this._mq.addEventListener('change', this._onMq);
      else if (this._mq.addListener) this._mq.addListener(this._onMq);

      /* bfcache restore: pageshow with persisted=true replays a document that may have
         been rendered at a different width entirely. */
      this._onPageShow = function (e) { if (e.persisted) kick(); };
      window.addEventListener('pageshow', this._onPageShow);

      /* Orientation can cross the breakpoint without firing a matchMedia change on
         every browser, and fires before the new viewport is readable. */
      this._onOrient = function () { setTimeout(kick, 120); };
      window.addEventListener('orientationchange', this._onOrient);

      /* Debounced resize as well, deliberately NOT relying on the matchMedia change
         event alone. That event is the tidy signal but it is not universally emitted -
         it did not fire at all under programmatic resize while testing, and a fix that
         depends on one event is a fix that silently does nothing when that event is
         missing. wrong() makes this cheap: it is a string compare, and it only touches
         the DOM when a slide is genuinely showing the wrong art. */
      this._onResizeAD = function () {
        clearTimeout(self.__adT);
        self.__adT = setTimeout(kick, 150);
      };
      window.addEventListener('resize', this._onResizeAD);

      kick();
    }

    disconnectedCallback() {
      this._stop();
      clearTimeout(this.resumeTimer);
      clearTimeout(this.__liftT);
      if (this._measureLift) window.removeEventListener('load', this._measureLift);
      if (this._onResizeLift) window.removeEventListener('resize', this._onResizeLift);
      if (this._onVis) document.removeEventListener('visibilitychange', this._onVis);
      if (this._onBlockSelect) document.removeEventListener('shopify:block:select', this._onBlockSelect);
      if (this._onBlockDeselect) document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
      if (this._onSecSelect) document.removeEventListener('shopify:section:select', this._onSecSelect);
      if (this._onSecDeselect) document.removeEventListener('shopify:section:deselect', this._onSecDeselect);
      if (this._mq && this._onMq) {
        if (this._mq.removeEventListener) this._mq.removeEventListener('change', this._onMq);
        else if (this._mq.removeListener) this._mq.removeListener(this._onMq);
      }
      if (this._onPageShow) window.removeEventListener('pageshow', this._onPageShow);
      if (this._onOrient) window.removeEventListener('orientationchange', this._onOrient);
      if (this._onResizeAD) { clearTimeout(this.__adT); window.removeEventListener('resize', this._onResizeAD); }
      this.__bbInit = false;
    }

    _start() {
      if (!this.autoplayOn) return;
      this._stop();
      var self = this;
      this.timer = setTimeout(function () { self._tick(); }, this.interval);
    }
    _stop() { if (this.timer) { clearTimeout(this.timer); this.timer = 0; } }
    _tick() {
      if (document.hidden || this.interacting) return;
      this.goTo((this.index + 1) % this.count, false);
    }

    next() { this.goTo((this.index + 1) % this.count, true); }
    prev() { this.goTo((this.index - 1 + this.count) % this.count, true); }

    goTo(n, manual) {
      /* Also re-check on every slide change. This is the one trigger that needs no
         DOM event at all, so the repair still lands even where resize / matchMedia
         change are not delivered - and "hero slide changes" was one of the reported
         failure paths. wrong() short-circuits on a string compare, so a correct slide
         costs nothing. */
      if (this._reselect) this._reselect();
      if (n == null || n < 0 || n >= this.count) return;
      if (n === this.index) { if (manual) this._bump(); return; }
      var from = this.index;
      this.index = n;
      this._sync(n, from);
      if (this.live) this.live.textContent = 'Slide ' + (n + 1) + ' of ' + this.count;
      this._preloadNext((n + 1) % this.count);
      if (manual) this._bump();
      else if (this.autoplayOn && !this.interacting && !document.hidden) this._start();
    }

    _sync(active, prev) {
      var tdur = this.tdur;
      this.slides.forEach(function (sl, k) {
        var isA = k === active;
        sl.classList.toggle('is-active', isA);
        if (k === prev && prev !== active && prev >= 0) {
          sl.classList.add('is-prev');
          (function (el) { setTimeout(function () { el.classList.remove('is-prev'); }, tdur); })(sl);
        } else if (!isA) {
          sl.classList.remove('is-prev');
        }
        if (isA) { sl.removeAttribute('inert'); sl.setAttribute('aria-hidden', 'false'); }
        else { sl.setAttribute('inert', ''); sl.setAttribute('aria-hidden', 'true'); }
      });
      this.dots.forEach(function (d, k) {
        var on = k === active;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) d.removeAttribute('tabindex'); else d.setAttribute('tabindex', '-1');
      });
    }

    _bump() {
      this._stop();
      clearTimeout(this.resumeTimer);
      if (!this.autoplayOn) return;
      var self = this;
      this.resumeTimer = setTimeout(function () { if (!self.interacting && !document.hidden) self._start(); }, Math.max(this.interval, 4000));
    }
    _deferResume() {
      clearTimeout(this.resumeTimer);
      if (!this.autoplayOn || document.hidden) return;
      var self = this;
      this.resumeTimer = setTimeout(function () { if (!self.interacting && !document.hidden) self._start(); }, 900);
    }

    _initSwipe() {
      var self = this, x0 = 0, y0 = 0, t0 = 0, active = false;
      var el = this.frame || this;
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); active = true;
        self.interacting = true; self._stop();
      });
      el.addEventListener('pointerup', function (e) {
        if (!active) return; active = false;
        var dx = e.clientX - x0, dy = e.clientY - y0, dt = Date.now() - t0;
        self.interacting = false;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4 && dt < 900) {
          if (dx < 0) self.next(); else self.prev();
        } else {
          self._deferResume();
        }
      });
      el.addEventListener('pointercancel', function () { active = false; self.interacting = false; self._deferResume(); });
    }

    _preloadNext(n) {
      if (this.count < 2) return;
      var slide = this.slides[n];
      if (!slide) return;
      var img = slide.querySelector('img');
      if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    }
  }

  if (window.customElements && !customElements.get('bb-hero-carousel')) customElements.define('bb-hero-carousel', BBHeroCarousel);

  /* Scroll cue — rebound on load + section reload (scoped strictly to the hero cue). */
  function bindScrollCue(scope) {
    (scope || document).querySelectorAll('.bb-hspot__scroll[data-bb-scroll]').forEach(function (el) {
      if (el.__bbBound) return; el.__bbBound = 1;
      function go() {
        var link = el.getAttribute('data-bb-scroll-link');
        if (link) { var tg = document.querySelector(link); if (tg) { tg.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; } }
        var sec = el.closest('.shopify-section');
        var nx = sec && sec.nextElementSibling;
        if (nx) nx.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else window.scrollBy({ top: Math.round(window.innerHeight * 0.85), behavior: 'smooth' });
      }
      el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(); });
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); go(); } });
    });
  }
  /* F203 - a hero button pointing at an anchor on THIS page scrolls to it instead of reloading.
     The href stays a real URL ("/#bb-inventory") so the theme editor's URL field keeps it, search
     engines see a normal link, and a click still works if this script never runs - it just costs a
     navigation. Modified clicks (new tab, middle click) are left to the browser on purpose, and
     prefers-reduced-motion gets an instant jump rather than a forced animation. Landing position
     comes from the target's own scroll-margin-top, so the sticky header is accounted for in one
     place rather than with pixel maths here. */
  function bbSamePageTarget(a) {
    var href = a.getAttribute('href') || '';
    var h = href.indexOf('#');
    if (h < 0 || href.length - h < 2) return null;
    var path = href.slice(0, h);
    if (path && path !== location.pathname && path !== location.origin + location.pathname) return null;
    try { return document.querySelector(href.slice(h)); } catch (e) { return null; }
  }
  function bindHeroAnchors(scope) {
    (scope || document).querySelectorAll('.bb-hspot__btn[href*="#"]').forEach(function (a) {
      if (a.__bbAnchor) return; a.__bbAnchor = 1;
      a.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
        var tg = bbSamePageTarget(a);
        if (!tg) return;
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var from = window.pageYOffset;
        tg.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        /* Some engines (older Safari, embedded webviews) accept behavior:'smooth' and then do
           nothing, which would leave the button dead. If nothing has moved shortly after, jump.
           A real scroll - animated or started by the shopper - moves pageYOffset and skips this. */
        if (!reduce) setTimeout(function () {
          if (Math.abs(window.pageYOffset - from) < 2) tg.scrollIntoView({ block: 'start' });
        }, 320);
        if (tg.id) {
          if (window.history && history.replaceState) history.replaceState(null, '', '#' + tg.id);
          /* keyboard users continue from the destination, as a real anchor would */
          if (!tg.hasAttribute('tabindex')) tg.setAttribute('tabindex', '-1');
          tg.focus({ preventScroll: true });
        }
      });
    });
  }

  if (document.readyState !== 'loading') { bindScrollCue(); bindHeroAnchors(); }
  else document.addEventListener('DOMContentLoaded', function () { bindScrollCue(); bindHeroAnchors(); });
  document.addEventListener('shopify:section:load', function (e) { bindScrollCue(e.target); bindHeroAnchors(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-inventory-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* F25 — shelf motion driver. Same logic as bb-lighting-carousel's script (touch-pause on the
     desktop marquee + the mobile auto-loop on the native swiper). It ships here too because
     Shopify only serves a section's javascript on pages where that section type renders — the
     homepage no longer renders bb-lighting-carousel. The shared data-bb-lc-ready guard means
     whichever copy runs first binds a given .bb-lc and the other is a no-op (never two loops). */
  var RESUME_MS = 2200;
  function initLc(lc) {
    if (!lc || lc.dataset.bbLcReady) return;
    var m = lc.querySelector('.bb-lc__marquee');
    var track = lc.querySelector('.bb-lc__track');
    if (!m || !track) return;
    lc.dataset.bbLcReady = '1';

    var tp;
    m.addEventListener('touchstart', function () { clearTimeout(tp); lc.classList.add('bb-lc--touchpause'); }, { passive: true });
    m.addEventListener('touchend', function () { clearTimeout(tp); tp = setTimeout(function () { lc.classList.remove('bb-lc--touchpause'); }, 1600); }, { passive: true });

    if (lc.classList.contains('bb-lc--static')) return;
    var mqM = window.matchMedia('(max-width: 749px)');
    var mqRM = window.matchMedia('(prefers-reduced-motion: reduce)');
    var rtl = lc.classList.contains('bb-lc--rtl');
    var raf = null, last = 0, pos = 0, paused = false, resumeT = null, selfScroll = false;

    /* F27 — per-frame getComputedStyle + scrollWidth reads forced a style/layout pass EVERY
       frame (the original choppiness root cause on mobile). The loop geometry is cached.
       F163 — the cache was still re-measured every ~120 frames, which is a FORCED SYNCHRONOUS
       LAYOUT (getComputedStyle = style recalc, scrollWidth = layout) roughly every 2 seconds
       while the strip is moving. That is a periodic late frame - a small hitch on a rhythm,
       which is exactly what "choppy" looks like rather than uniformly slow.
       It is now event-driven instead of polled: the only things that can change this geometry
       are the track resizing (breakpoint, rotation, font swap) and images finishing load and
       changing the track's width. A ResizeObserver catches both, because a late image landing
       changes track.scrollWidth. So the measurement still happens exactly when it must, and
       never on a timer during animation. */
    var cachedW = 0, cachedDur = 60;
    function refreshCache() {
      var copies = parseFloat(getComputedStyle(track).getPropertyValue('--bb-lc-copies')) || 2;
      cachedW = copies > 0 ? track.scrollWidth / copies : 0;
      cachedDur = parseFloat(getComputedStyle(lc).getPropertyValue('--bb-lc-dur')) || 60;
    }
    function copyW() { return cachedW; }
    if (window.ResizeObserver) {
      /* observes the TRACK, so a late-loading image that widens it re-measures on its own. */
      new ResizeObserver(function () { refreshCache(); }).observe(track);
    } else {
      window.addEventListener('resize', refreshCache, { passive: true });
      /* capture:true - load does not bubble from <img>, but it does reach a capturing ancestor. */
      track.addEventListener('load', refreshCache, true);
    }
    function step(ts) {
      raf = requestAnimationFrame(step);
      if (paused || document.hidden) { last = ts; return; }
      if (!last) { last = ts; return; }
      var dt = Math.min(64, ts - last);
      last = ts;
      var w = copyW();
      if (!w) return;

      /* F163 — SUB-PIXEL MOTION. THE JUDDER WAS QUANTISATION, NOT SPEED.
         Measured on the live strip: the loop wants 1.155px per frame, and scrollLeft actually
         applied 1px or 2px and nothing in between - the engine rounds scrollLeft to whole CSS
         pixels. So the strip advanced 1,1,2,1,1,2..., a ~45% frame-to-frame speed wobble. That
         is the choppiness, and no amount of extra speed removes it - it only dilutes the
         relative error (F30's read-back correction assumed device-pixel granularity, which this
         engine does not give).
         The fix is to stop asking scrollLeft to express fractions. Position is kept here as a
         float; the WHOLE pixels go to scrollLeft, so the native scrollbar stays truthful and
         manual swipe still works (both F153 requirements), and the leftover FRACTION is carried
         as a translate3d on the track - a compositor-only transform that is genuinely sub-pixel
         and costs no layout or paint. Net visible position advances by an exact, constant
         1.155px every frame.
         Position is also no longer read back from the DOM each frame, which removes two forced
         scroll/layout reads per frame; pos is re-synced from scrollLeft whenever the user takes
         over (see pause/scheduleResume), so a swipe or fling can never desync it. */
      pos += (w / cachedDur) * (dt / 1000) * (rtl ? -1 : 1);
      if (pos >= w) pos -= w;
      if (pos < 0) pos += w;
      var whole = Math.round(pos);
      selfScroll = true;
      m.scrollLeft = whole;
      var frac = pos - whole; /* -0.5 .. 0.5 */
      track.style.transform = 'translate3d(' + (-frac).toFixed(3) + 'px,0,0)';
    }
    /* Hand the exact position back to the browser before the user touches it, so nothing jumps:
       drop the sub-pixel transform and let scrollLeft alone describe where the strip is. */
    function syncFromDom() { pos = m.scrollLeft; track.style.transform = ''; }
    function start() {
      if (raf) return;
      lc.classList.add('bb-lc--mauto');
      refreshCache();
      if (rtl && m.scrollLeft <= 0) { selfScroll = true; m.scrollLeft = copyW(); }
      last = 0;
      syncFromDom();
      raf = requestAnimationFrame(step);
    }
    function stop() {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
      track.style.transform = ''; /* never leave a sub-pixel offset behind on a stopped strip */
      lc.classList.remove('bb-lc--mauto');
    }
    function pause() { paused = true; if (resumeT) clearTimeout(resumeT); syncFromDom(); }
    function scheduleResume() {
      if (resumeT) clearTimeout(resumeT);
      resumeT = setTimeout(function () { syncFromDom(); paused = false; }, RESUME_MS);
    }
    m.addEventListener('touchstart', pause, { passive: true });
    m.addEventListener('pointerdown', pause, { passive: true });
    m.addEventListener('touchend', scheduleResume, { passive: true });
    m.addEventListener('touchcancel', scheduleResume, { passive: true });
    m.addEventListener('pointerup', scheduleResume, { passive: true });
    m.addEventListener('scroll', function () {
      if (selfScroll) { selfScroll = false; return; }
      pause();
      scheduleResume();
    }, { passive: true });
    m.addEventListener('focusin', pause);
    m.addEventListener('focusout', scheduleResume);
    /* F154 - restore PAUSE ON HOVER for desktop. Until F153 this was pure CSS
       (animation-play-state on :hover). F153 switched the desktop strip to the scrollLeft
       loop and turned the CSS animation off, so that rule silently stopped doing anything
       and the strip kept sliding under the cursor. It matters more now than it did before:
       Quick view / Add only appear on hover, and revealing controls on a strip that is still
       moving is unusable. Honours the same Pause-on-hover setting, which reaches the DOM as
       .bb-lc--nopause when the merchant switches it off. */
    if (!lc.classList.contains('bb-lc--nopause')) {
      m.addEventListener('mouseenter', pause);
      m.addEventListener('mouseleave', scheduleResume);
    }
    /* F153 - the scroll-driven loop now runs at EVERY width, not just <750px, so the desktop
       strip is a real scroller and the browser's own horizontal scrollbar is accurate: the
       position lives in scrollLeft, the thumb tracks the strip, and dragging it works. The
       CSS transform marquee is switched off by .bb-lc--mauto (added by start()), so the two
       motion systems can never run together. mqM is still read below for the mobile-only
       snap/padding behaviour.

       NOTE: this file carries its OWN COPY of the carousel JS - the header comment says it
       reuses bb-lighting-carousel's, which is true of the CSS but NOT of this script. Both
       compile into scripts.js. If you change the loop in one, change it in the other or the
       homepage shelf and the standalone lighting section will silently diverge. */
    function sync() {
      if (!lc.isConnected) { stop(); return; } /* editor removed the section — never resurrect the loop */
      if (!mqRM.matches) start(); else stop();
    }
    if (mqM.addEventListener) { mqM.addEventListener('change', sync); mqRM.addEventListener('change', sync); }
    sync();
    lc.bbLcStop = stop;
  }

  /* F25 — inventory-hub shelf arrows. The shelf itself is driven by the initLc logic above;
     these buttons just nudge the native scroller by one card. In desktop marquee mode the
     arrows are hidden by CSS. Idempotent per section; listeners die with the DOM on Theme
     Editor reloads (no document-level state). */
  function init(scope) {
    (scope || document).querySelectorAll('.bb-ihub').forEach(function (root) {
      if (root.__bbIhub) return;
      root.__bbIhub = 1;
      var shelf = root.querySelector('.bb-ihub__lc');
      if (shelf) initLc(shelf);
      var nav = root.querySelector('[data-bb-ihub-nav]');
      var m = root.querySelector('.bb-ihub__lc .bb-lc__marquee');
      if (!nav || !m) return;
      function stepPx() {
        var item = m.querySelector('.bb-lc__item');
        if (!item) return 260;
        var cs = getComputedStyle(item);
        return item.getBoundingClientRect().width + (parseFloat(cs.marginRight) || 0);
      }
      var prev = nav.querySelector('[data-bb-ihub-prev]');
      var next = nav.querySelector('[data-bb-ihub-next]');
      function canLoop() {
        // duplicate copies present = infinite wrap; never disable the arrows
        return !!m.querySelector('.bb-lc__item--dup[aria-hidden]') && getComputedStyle(m.querySelector('.bb-lc__item--dup')).display !== 'none';
      }
      function syncDisabled() {
        if (canLoop()) { prev.disabled = false; next.disabled = false; return; }
        prev.disabled = m.scrollLeft <= 2;
        next.disabled = m.scrollLeft >= m.scrollWidth - m.clientWidth - 2;
      }
      var smoothOk = 'scrollBehavior' in document.documentElement.style;
      function nudge(px) {
        /* the auto-loop only pauses on marquee touch/scroll — an arrow tap is outside it, so
           without an explicit pause the loop would overwrite the tap every frame. Synthetic
           touchstart/touchend hit the same pause/resume listeners regardless of WHICH initLc
           copy (hub or lighting section) bound this shelf. */
        m.dispatchEvent(new Event('touchstart'));
        if (smoothOk) m.scrollBy({ left: px, behavior: 'smooth' });
        else m.scrollLeft += px; /* older Safari ignores ScrollToOptions */
        m.dispatchEvent(new Event('touchend'));
      }
      prev.addEventListener('click', function () { nudge(-stepPx()); });
      next.addEventListener('click', function () { nudge(stepPx()); });
      m.addEventListener('scroll', syncDisabled, { passive: true });
      syncDisabled();
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    // also drive any standalone .bb-lc the editor adds to a page whose bundle lacks the
    // lighting section's own script — the shared data-bb-lc-ready guard keeps this a no-op
    // wherever that script exists
    e.target.querySelectorAll('.bb-lc').forEach(initLc);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.bb-lc').forEach(function (lc) { if (lc.bbLcStop) lc.bbLcStop(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-lighting-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RESUME_MS = 2200;
  function initLc(lc) {
    if (!lc || lc.dataset.bbLcReady) return;
    var m = lc.querySelector('.bb-lc__marquee');
    var track = lc.querySelector('.bb-lc__track');
    if (!m || !track) return;
    lc.dataset.bbLcReady = '1';

    /* F88 — dup slides must be CLICKABLE but not TABBABLE. A previous pass put `inert` on them,
       which silenced screen-reader duplication and fixed the aria-hidden-with-focusable-links
       violation — but inert also blocks the MOUSE, and with several marquee copies most visible
       cards are dups, so clicks "sometimes" did nothing. This strips inert wherever it appears
       (belt and suspenders against cached renders) and removes dup links from the tab order,
       which is the accessibility half of what inert was doing. */
    lc.querySelectorAll('.bb-lc__item--dup').forEach(function (li) {
      li.removeAttribute('inert');
      li.querySelectorAll('a, button, input, [tabindex]').forEach(function (el) { el.tabIndex = -1; });
    });

    // Desktop CSS marquee: pause while a finger is on the strip (kept from F13).
    var tp;
    m.addEventListener('touchstart', function () { clearTimeout(tp); lc.classList.add('bb-lc--touchpause'); }, { passive: true });
    m.addEventListener('touchend', function () { clearTimeout(tp); tp = setTimeout(function () { lc.classList.remove('bb-lc--touchpause'); }, 1600); }, { passive: true });

    /* F14 Part 6 — mobile auto-loop on the native swiper. The <750px strip is a real overflow-x
       scroller (so manual swipe always works); this loop advances scrollLeft each frame and wraps
       by exactly one copy width (scrollWidth/copies — recomputed live, so image loads can't drift
       it). Any user input (touch, drag, momentum scroll, focus) pauses; RESUME_MS of quiet resumes.
       Wrapping is position-preserving modulo the copy width, so a wrap right after a user fling is
       still seamless. Off entirely when Auto-scroll is off or reduced motion is set. */
    if (lc.classList.contains('bb-lc--static')) return;
    var mqM = window.matchMedia('(max-width: 749px)');
    var mqRM = window.matchMedia('(prefers-reduced-motion: reduce)');
    var rtl = lc.classList.contains('bb-lc--rtl');
    var raf = null, last = 0, pos = 0, paused = false, resumeT = null, selfScroll = false;

    /* F27 — per-frame getComputedStyle + scrollWidth reads forced a style/layout pass EVERY
       frame (the original choppiness root cause on mobile). The loop geometry is cached.
       F163 — the cache was still re-measured every ~120 frames, which is a FORCED SYNCHRONOUS
       LAYOUT (getComputedStyle = style recalc, scrollWidth = layout) roughly every 2 seconds
       while the strip is moving. That is a periodic late frame - a small hitch on a rhythm,
       which is exactly what "choppy" looks like rather than uniformly slow.
       It is now event-driven instead of polled: the only things that can change this geometry
       are the track resizing (breakpoint, rotation, font swap) and images finishing load and
       changing the track's width. A ResizeObserver catches both, because a late image landing
       changes track.scrollWidth. So the measurement still happens exactly when it must, and
       never on a timer during animation. */
    var cachedW = 0, cachedDur = 60;
    function refreshCache() {
      var copies = parseFloat(getComputedStyle(track).getPropertyValue('--bb-lc-copies')) || 2;
      cachedW = copies > 0 ? track.scrollWidth / copies : 0;
      cachedDur = parseFloat(getComputedStyle(lc).getPropertyValue('--bb-lc-dur')) || 60;
    }
    function copyW() { return cachedW; }
    if (window.ResizeObserver) {
      /* observes the TRACK, so a late-loading image that widens it re-measures on its own. */
      new ResizeObserver(function () { refreshCache(); }).observe(track);
    } else {
      window.addEventListener('resize', refreshCache, { passive: true });
      /* capture:true - load does not bubble from <img>, but it does reach a capturing ancestor. */
      track.addEventListener('load', refreshCache, true);
    }
    function step(ts) {
      raf = requestAnimationFrame(step);
      if (paused || document.hidden) { last = ts; return; }
      if (!last) { last = ts; return; }
      var dt = Math.min(64, ts - last);
      last = ts;
      var w = copyW();
      if (!w) return;

      /* F163 — SUB-PIXEL MOTION. THE JUDDER WAS QUANTISATION, NOT SPEED.
         Measured on the live strip: the loop wants 1.155px per frame, and scrollLeft actually
         applied 1px or 2px and nothing in between - the engine rounds scrollLeft to whole CSS
         pixels. So the strip advanced 1,1,2,1,1,2..., a ~45% frame-to-frame speed wobble. That
         is the choppiness, and no amount of extra speed removes it - it only dilutes the
         relative error (F30's read-back correction assumed device-pixel granularity, which this
         engine does not give).
         The fix is to stop asking scrollLeft to express fractions. Position is kept here as a
         float; the WHOLE pixels go to scrollLeft, so the native scrollbar stays truthful and
         manual swipe still works (both F153 requirements), and the leftover FRACTION is carried
         as a translate3d on the track - a compositor-only transform that is genuinely sub-pixel
         and costs no layout or paint. Net visible position advances by an exact, constant
         1.155px every frame.
         Position is also no longer read back from the DOM each frame, which removes two forced
         scroll/layout reads per frame; pos is re-synced from scrollLeft whenever the user takes
         over (see pause/scheduleResume), so a swipe or fling can never desync it. */
      pos += (w / cachedDur) * (dt / 1000) * (rtl ? -1 : 1);
      if (pos >= w) pos -= w;
      if (pos < 0) pos += w;
      var whole = Math.round(pos);
      selfScroll = true;
      m.scrollLeft = whole;
      var frac = pos - whole; /* -0.5 .. 0.5 */
      track.style.transform = 'translate3d(' + (-frac).toFixed(3) + 'px,0,0)';
    }
    /* Hand the exact position back to the browser before the user touches it, so nothing jumps:
       drop the sub-pixel transform and let scrollLeft alone describe where the strip is. */
    function syncFromDom() { pos = m.scrollLeft; track.style.transform = ''; }
    function start() {
      if (raf) return;
      lc.classList.add('bb-lc--mauto');
      refreshCache();
      if (rtl && m.scrollLeft <= 0) { selfScroll = true; m.scrollLeft = copyW(); }
      last = 0;
      syncFromDom();
      raf = requestAnimationFrame(step);
    }
    function stop() {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
      track.style.transform = ''; /* never leave a sub-pixel offset behind on a stopped strip */
      lc.classList.remove('bb-lc--mauto');
    }
    function pause() { paused = true; if (resumeT) clearTimeout(resumeT); syncFromDom(); }
    function scheduleResume() {
      if (resumeT) clearTimeout(resumeT);
      resumeT = setTimeout(function () { syncFromDom(); paused = false; }, RESUME_MS);
    }
    m.addEventListener('touchstart', pause, { passive: true });
    m.addEventListener('pointerdown', pause, { passive: true });
    m.addEventListener('touchend', scheduleResume, { passive: true });
    m.addEventListener('touchcancel', scheduleResume, { passive: true });
    m.addEventListener('pointerup', scheduleResume, { passive: true });
    m.addEventListener('scroll', function () {
      if (selfScroll) { selfScroll = false; return; }
      // user-driven scroll (incl. momentum after the finger lifts): keep deferring the resume
      pause();
      scheduleResume();
    }, { passive: true });
    m.addEventListener('focusin', pause);
    m.addEventListener('focusout', scheduleResume);
    /* F154 - restore PAUSE ON HOVER for desktop. Until F153 this was pure CSS
       (animation-play-state on :hover). F153 switched the desktop strip to the scrollLeft
       loop and turned the CSS animation off, so that rule silently stopped doing anything
       and the strip kept sliding under the cursor. It matters more now than it did before:
       Quick view / Add only appear on hover, and revealing controls on a strip that is still
       moving is unusable. Honours the same Pause-on-hover setting, which reaches the DOM as
       .bb-lc--nopause when the merchant switches it off. */
    if (!lc.classList.contains('bb-lc--nopause')) {
      m.addEventListener('mouseenter', pause);
      m.addEventListener('mouseleave', scheduleResume);
    }
    /* F153 - the scroll-driven loop now runs at EVERY width, not just <750px. On desktop it
       replaces the CSS transform marquee (killed by .bb-lc--mauto), which is what lets the
       browser's own horizontal scrollbar be accurate: position lives in scrollLeft, so the
       thumb tracks the strip and dragging it just works. mqM is still read below so the
       mobile-only scroll-snap/padding rules keep their existing behaviour. */
    function sync() { if (!mqRM.matches) start(); else stop(); }
    if (mqM.addEventListener) { mqM.addEventListener('change', sync); mqRM.addEventListener('change', sync); }
    sync();
    lc.bbLcStop = stop;
  }
  function initAll(scope) { (scope || document).querySelectorAll('.bb-lc').forEach(initLc); }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.bb-lc').forEach(function (lc) { if (lc.bbLcStop) lc.bbLcStop(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.bbReady) return;
    root.dataset.bbReady = '1';
    var track = root.querySelector('[data-rev-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    var container = root.closest('.bb-container') || document;
    var dotsWrap = container.querySelector('[data-rev-dots]');
    var prev = container.querySelector('[data-rev-prev]');
    var next = container.querySelector('[data-rev-next]');
    var autoplay = (parseFloat(root.dataset.autoplay) || 0) * 1000;
    if (!cards.length) return;

    var dots = [];
    if (dotsWrap) {
      cards.forEach(function (c, i) {
        var d = document.createElement('button');
        d.className = 'bb-rev__dot'; d.type = 'button'; d.setAttribute('aria-label', 'Go to review ' + (i + 1));
        d.addEventListener('click', function () { scrollTo(i); restart(); });
        dotsWrap.appendChild(d); dots.push(d);
      });
    }
    function step() { return cards[0].getBoundingClientRect().width + 16; }
    function activeIndex() { return Math.round(track.scrollLeft / step()); }
    function setDots() { var a = activeIndex(); dots.forEach(function (d, i) { d.classList.toggle('is-active', i === a); }); }
    function scrollTo(i) { track.scrollTo({ left: i * step(), behavior: 'smooth' }); }
    function go(dir) {
      var a = activeIndex(), max = cards.length - 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      var n = dir > 0 ? (atEnd ? 0 : a + 1) : (a <= 0 ? max : a - 1);
      scrollTo(n);
    }
    if (prev) prev.addEventListener('click', function () { go(-1); restart(); });
    if (next) next.addEventListener('click', function () { go(1); restart(); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(setDots); }, { passive: true });
    setDots();

    var timer = null;
    function start() { if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; if (autoplay > 0 && cards.length > 1) { stop(); timer = setInterval(function () { go(1); }, autoplay); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }
    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', start);
    root.addEventListener('pointerdown', stop);
    start();
  }
  document.querySelectorAll('[data-rev]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-rev]'); if (el) init(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-trusted-best"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* F24/F27b — mobile full-screen Trusted video (same proven pattern as the About video hero):
     the src is assigned only on mobile viewports (desktop never downloads it), the native
     `autoplay` attribute + muted PROPERTY drive playback, there is NO play button (a blocked
     autoplay is started silently by the first scroll/tap), and the video pauses while the tab
     is hidden. On desktop, the grid video (deferred in fullscreen mode so hidden mobile copies
     don't download) is started muted here instead. Idempotent per element — safe across Theme
     Editor section reloads (fresh DOM = fresh init; no document-level listeners leak). */
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var MOB = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };

  /* F45 — every live full-screen video registers here, and the document/window listeners that
     resume playback are bound EXACTLY ONCE per page. Detached roots (theme-editor section
     reloads) are dropped on each pass, so nothing leaks and nothing double-fires. */
  var REGISTRY = [];
  var globalsBound = false;
  function eachLive(fn) {
    for (var i = REGISTRY.length - 1; i >= 0; i--) {
      if (!REGISTRY[i].root.isConnected) { REGISTRY.splice(i, 1); continue; }
      fn(REGISTRY[i]);
    }
  }
  function resumeAll() {
    if (!MOB.matches || RM.matches || document.hidden) return;
    eachLive(function (r) { if (r.isInView() && r.video.paused) r.play(); });
  }
  function bindGlobals() {
    if (globalsBound) return;
    globalsBound = true;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        eachLive(function (r) { if (r.video.getAttribute('src')) { try { r.video.pause(); } catch (e) {} } });
      } else {
        resumeAll();
      }
    });
    /* back/forward (bfcache) restores a PAUSED video with the poster already faded out — resume
       so it is never a frozen frame. Also covers a plain re-show of the tab. */
    window.addEventListener('pageshow', resumeAll);
    window.addEventListener('focus', resumeAll);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.bb-tb--fs').forEach(function (root) {
      if (root.__bbTbFs) return;
      root.__bbTbFs = 1;
      var video = root.querySelector('[data-bb-tb-fs-video]');
      var gridVideo = root.querySelector('.bb-tb__frame video');
      var fsEl = root.querySelector('.bb-tb__fs');

      /* F29 — reliability fix (video played in the editor but froze on real mobile). ROOT CAUSE:
         preload="none" + a src assigned only at 22% visibility meant the heavy 1080p file had no
         time to buffer on cellular, so the poster sat frozen over an unloaded video. Now the src
         is assigned and buffered AHEAD of the section (preload=auto), so it is ready to play the
         moment it scrolls in. */
      function loadSrc() {
        if (!video || !MOB.matches || video.getAttribute('src')) return;
        var s = video.getAttribute('data-src');
        if (!s) return;
        video.preload = 'auto';
        video.setAttribute('src', s);
        try { video.load(); } catch (e) {}
      }
      function reveal() { root.classList.add('bb-tb--fs-playing'); unbindKick(); }
      var inView = false;
      var pauseTimer = null;
      function tryPlay() {
        if (!video || !MOB.matches || RM.matches) return; /* reduced motion → poster stays, no control */
        if (pauseTimer) { clearTimeout(pauseTimer); pauseTimer = null; }
        loadSrc();
        /* F45 — defaultMuted mirrors the MUTED ATTRIBUTE, which is what iOS actually consults when
           it re-evaluates autoplay eligibility (e.g. after load() resets the element). Setting only
           the .muted property left a window where a reset element looked unmuted and play() was
           rejected — one of the "sometimes it just doesn't start" cases. */
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        var p = video.play(); /* nudge beside the native autoplay attribute */
        if (p && p.catch) p.catch(function () {});
      }
      /* F45 — pausing is DELAYED and cancellable: a fling-scroll can drive the ratio through 0 and
         back within a frame or two, and pausing/replaying on each crossing produced the flicker
         (and, when a pause landed between play() and its promise, a stuck poster). */
      function pauseSoon() {
        if (pauseTimer || !video) return;
        pauseTimer = setTimeout(function () {
          pauseTimer = null;
          if (!inView) { try { video.pause(); } catch (err) {} }
        }, 450);
      }
      function activateDesktop() {
        if (!gridVideo || MOB.matches || RM.matches) return;
        gridVideo.muted = true;
        var p = gridVideo.play();
        if (p && p.catch) p.catch(function () {});
      }

      /* Silent one-shot gesture kick — no visible control, ever. Ungated from inView so the
         first gesture ANYWHERE recovers a blocked autoplay (iOS Low Power Mode). */
      var kicked = false;
      var GEVTS = ['touchstart', 'pointerdown', 'scroll', 'keydown', 'click'];
      var gopts = { passive: true, capture: true };
      function unbindKick() { GEVTS.forEach(function (ev) { window.removeEventListener(ev, kick, gopts); }); }
      function kick() {
        if (kicked || !MOB.matches || RM.matches) return;
        kicked = true; unbindKick();
        tryPlay();
      }
      if (video && !RM.matches) GEVTS.forEach(function (ev) { window.addEventListener(ev, kick, gopts); });

      if (video) {
        /* reveal on `playing` OR once the video is genuinely advancing — some iOS builds fire
           `playing` unreliably, so timeupdate is the authoritative "it's really moving" signal.
           This is what lifts the poster; without it a playing video could stay hidden = frozen. */
        video.addEventListener('playing', reveal);
        video.addEventListener('timeupdate', function () { if (video.currentTime > 0.05) reveal(); });
        video.addEventListener('loadeddata', function () { if (MOB.matches && !RM.matches && inView && video.paused) tryPlay(); });
        video.addEventListener('canplay', function () { if (MOB.matches && !RM.matches && inView && video.paused) tryPlay(); });
        /* a rejected/aborted play() leaves it paused with no further media events — if we are
           still in view, take one more run at it on the next frame */
        video.addEventListener('pause', function () {
          if (!MOB.matches || RM.matches || !inView || pauseTimer || document.hidden) return;
          setTimeout(function () { if (inView && video.paused && !document.hidden) tryPlay(); }, 250);
        });
        /* F45 — document-level listeners are registered ONCE PER PAGE (not per section root):
           a section reload builds a fresh root, and the old per-root listeners used to survive
           against a detached video. The registry always drives the roots that are still live. */
        REGISTRY.push({ root: root, video: video, isInView: function () { return inView; }, play: tryPlay });
        bindGlobals();

        if (fsEl && 'IntersectionObserver' in window) {
          /* PRELOAD: begin buffering as the section approaches (~1 screen out) so it is ready
             before it is visible. On the homepage Trusted sits right after the hero, so this
             fires shortly after first paint — the video streams at the browser's low off-screen
             priority and never competes with the hero LCP image. */
          new IntersectionObserver(function (entries, obs) {
            if (MOB.matches && entries[entries.length - 1].isIntersecting) { loadSrc(); obs.disconnect(); }
          }, { rootMargin: '120% 0px 120% 0px' }).observe(fsEl);
          /* PLAY: start as the section APPROACHES (15% of it, or a quarter-screen of it for a
             section taller than the viewport — the old 0.22 ratio could not be reached on short
             viewports), and only give up once it is fully gone. Extra thresholds mean the
             callback actually fires while it enters, instead of only at 0 / 0.25 crossings. */
          new IntersectionObserver(function (entries) {
            var e = entries[entries.length - 1];
            if (!MOB.matches) return;
            var showing = e.isIntersecting &&
              (e.intersectionRatio >= 0.15 || e.intersectionRect.height >= window.innerHeight * 0.25);
            if (showing) { inView = true; tryPlay(); }
            else if (!e.isIntersecting || e.intersectionRatio === 0) { inView = false; pauseSoon(); }
          }, { threshold: [0, 0.05, 0.15, 0.3, 0.6], rootMargin: '10% 0px 10% 0px' }).observe(fsEl);
        } else {
          inView = true;
          tryPlay(); /* no IO support: previous always-play behavior */
        }
      }

      activateDesktop();
      if (MOB.addEventListener) MOB.addEventListener('change', function (e) {
        if (e.matches) { if (inView) tryPlay(); if (gridVideo) { try { gridVideo.pause(); } catch (err) {} } }
        else { if (video) { try { video.pause(); } catch (err) {} } activateDesktop(); }
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-vehicle-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var form = root.querySelector('[data-bb-vbar]');
    if (!form || form.dataset.bbReady) return;
    form.dataset.bbReady = '1';
    var make = form.querySelector('[data-bb-vbar-make]');
    var model = form.querySelector('[data-bb-vbar-model]');
    var go = form.querySelector('[data-bb-vbar-go]');
    function filterModels() {
      if (!model) return;
      var mk = make ? make.value : '';
      Array.prototype.forEach.call(model.options, function (opt) {
        if (!opt.value) return; /* keep placeholder */
        var om = opt.getAttribute('data-make');
        var show = !om || !mk || om === mk;
        opt.hidden = !show;
        opt.disabled = !show;
      });
      model.value = '';
      if (go) go.disabled = true;
    }
    if (make) make.addEventListener('change', filterModels);
    if (model && go) { model.addEventListener('change', function () { go.disabled = !model.value; }); }
    filterModels();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!model || !model.value) return;
      window.location.href = model.value;
    });
  }
  document.querySelectorAll('.bb-vbar').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector) init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    function initHmm(root) {
      var form = root.querySelector('[data-bb-hmm-form]');
      if (!form || form.dataset.bbReady) return;
      form.dataset.bbReady = '1';
      var make = form.querySelector('[data-bb-hmm-make]');
      var model = form.querySelector('[data-bb-hmm-model]');
      var go = form.querySelector('[data-bb-hmm-go]');
      function filterModels() {
        if (!model) return;
        var mk = make ? make.value : '';
        Array.prototype.forEach.call(model.options, function (opt) {
          if (!opt.value) return; /* keep placeholder */
          var om = opt.getAttribute('data-make');
          var show = !om || !mk || om === mk;
          opt.hidden = !show;
          opt.disabled = !show;
        });
        model.value = '';
        if (go) go.disabled = true;
      }
      if (make) make.addEventListener('change', filterModels);
      if (model && go) { model.addEventListener('change', function () { go.disabled = !model.value; }); }
      filterModels();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!model || !model.value) return;
        window.location.href = model.value;
      });
    }
    function boot() { document.querySelectorAll('[data-bb-hmm]').forEach(initHmm); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelectorAll) e.target.querySelectorAll('[data-bb-hmm]').forEach(initHmm); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  // Continuous auto-scroll on a native scroll container: constant motion, native swipe/drag,
  // arrow stepping, seamless wrap at one copy-width. Pauses while the user interacts.
  function initRel(m) {
    if (m.dataset.bbRelReady) return;
    m.dataset.bbRelReady = '1';
    var track = m.querySelector('.bb-rel__track');
    if (!track) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var copies = parseInt(getComputedStyle(track).getPropertyValue('--bb-rel-copies')) || 2;
    var dur = Math.max(10, parseFloat(m.getAttribute('data-bb-rel-dur') || '30'));
    var paused = false, hover = false, idleTimer, carry = 0, last;

    function copyWidth() { return track.scrollWidth / copies; }
    function wrap() {
      var cw = copyWidth();
      if (cw > 0 && m.scrollLeft >= cw) m.scrollLeft -= cw;
      else if (m.scrollLeft <= 0 && cw > 0) m.scrollLeft += cw;
    }
    function frame(ts) {
      if (last === undefined) last = ts;
      var dt = Math.min(64, ts - last);
      last = ts;
      if (!paused && !hover && !reduce) {
        carry += (copyWidth() / (dur * 1000)) * dt;
        var px = Math.floor(carry);
        if (px > 0) { m.scrollLeft += px; carry -= px; wrap(); }
      }
      requestAnimationFrame(frame);
    }
    function rest(ms) {
      paused = true;
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () { paused = false; }, ms);
    }
    if (m.classList.contains('bb-rel__marquee--pause')) {
      m.addEventListener('mouseenter', function () { hover = true; });
      m.addEventListener('mouseleave', function () { hover = false; });
    }
    m.addEventListener('touchstart', function () { rest(2200); }, { passive: true });
    m.addEventListener('touchmove', function () { rest(2200); }, { passive: true });
    m.addEventListener('wheel', function () { rest(1800); }, { passive: true });
    m.addEventListener('focusin', function () { rest(4000); });
    // start mid-strip so both directions have runway, then run
    requestAnimationFrame(function () { m.scrollLeft = 1; requestAnimationFrame(frame); });

    var wrapEl = m.closest('.bb-rel__wrap');
    function step(dir) {
      var it = track.querySelector('.bb-rel__item');
      if (!it) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      rest(2600);
      m.scrollBy({ left: dir * (it.getBoundingClientRect().width + gap), behavior: 'smooth' });
      setTimeout(wrap, 600);
    }
    if (wrapEl) {
      var prev = wrapEl.querySelector('[data-bb-rel-prev]');
      var next = wrapEl.querySelector('[data-bb-rel-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    }
  }
  function initAll() { document.querySelectorAll('[data-bb-rel-auto]').forEach(initRel); }
  initAll();
  // Pass 2E: the recommendations variant injects its HTML after a fetch — init those too.
  document.querySelectorAll('product-recommendations').forEach(function (pr) {
    new MutationObserver(initAll).observe(pr, { childList: true, subtree: true });
  });
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
